import { Component, OnInit, ViewChild } from '@angular/core';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable, Observer, Subject } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiRequestService, CommonUtilty, InteractService, IntimationService,AppMetadataHandler } from 'app';
import { Router } from '@angular/router';
import { AppConfig } from 'app';
import { default as intimationConfig } from '../../Claims/intimation/search-intimation/search-intimation.component.json';
import { default as loaderMessages} from './loader_messages.json';
import { DomSanitizer } from '@angular/platform-browser';
import { DataTransformService } from './../../shared-services/data-transform/data-transform.service';
import { environment } from 'environments/environment';
import { ViewSummaryJsonTransformService } from 'app/BaseFramework/core/services/JSON-transform/view-summary-json-transform.service';
import * as CryptoJS from 'crypto-js';
import { NzCascaderOption } from 'ng-zorro-antd/cascader';
declare var Tiff: any;
import { ChartComponent,ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart,
  ApexFill,
  ApexDataLabels,
  ApexLegend } from "ng-apexcharts";

export type ChartOptions = {
    series: ApexNonAxisChartSeries;
    chart: ApexChart;
    responsive: ApexResponsive[];
    labels: any;
    colors: string[];
    fill: ApexFill;
    legend: ApexLegend;
    dataLabels: ApexDataLabels;
};
@Component({
  selector: 'app-ocr-case-creation',
  templateUrl: './ocr-case-creation.component.html',
  styleUrls: ['./ocr-case-creation.component.scss']
})
export class OcrCaseCreationComponent implements OnInit {
  
  configData = null;
  constructor(private msg: NzMessageService,
    private apiRequestService: ApiRequestService,
    private http: HttpClient,
    private commonUtility: CommonUtilty,
    private router: Router,
    private intimationService : IntimationService,
    private interactService : InteractService,
    private appConfig : AppConfig,
    private sanitizer: DomSanitizer,
    public appMetadataHandler: AppMetadataHandler,
    public dataTransformService: DataTransformService,
    public jsonTransformService : ViewSummaryJsonTransformService
  ) {
    this.fetchRouteStateData();
    // this.setConfigForInterpretationMetrics()
    this.configData = intimationConfig;
  }
  idp_guid : string = "";
  claimOCR_URL = `https://${this.appConfig.serverHost}/dev-fwa-generic/ocr/life_claim_creation`;
  allowedFileSize = 10;  /* in MB */
  fileFormatSupported = [ // Add all supported formats here
    'jpg', 'png', 'jpeg', //Images
    'pdf', // PDF Doc
    'zip' // Zip files
  ];
  chartOptions = {}
  loaderMsges = loaderMessages
  intervalId: any;
  // sampleAuditOutput = sampleRespJSON;
  currentModeKey = "";
  OCRModes = [
    {
      "name" : "No-Touch AutoFlow",
      "idp_version" : "v1",
      "key" : "IDPV1",
      "icon" : "thunderbolt",
      "enable" : true,
      "visible" : false,
      "api" : `https://${this.appConfig.serverHost}/dev-fwa-generic/ocr/life_claim_creation`
    },
    {
      "name" : "Extraction Testing",
      "key" : "EXTRACTIONTESTING",
      "idp_version" : "EXTRACTION",
      "enable" : true,
      "icon" : "thunderbolt",
      "visible" : false,
      "api" : `https://${this.appConfig.serverHost}/dev-fwa-generic/idp/initiate_idp`
    },
    {
      "name" : "Auto Flow",
      "key" : "INITIATEIDP",
      "idp_version" : "AUTO_FLOW",
      "icon" : "thunderbolt",
      "enable" : true,
      "visible" : true,
      "api" : `https://${this.appConfig.serverHost}/dev-fwa-generic/idp/initiate_idp`
    },
    {
      "name" : "Version 2",
      "key" : "IDPV2",
      "idp_version" : "v2",
      "icon" : "tool",
      "enable" : true,
      "visible" : true,
      "api" : `https://${this.appConfig.serverHost}/dev-fwa-generic/idp/get_classification`
    },
    {
      "name" : "Version 3",
      "key" : "IDPV3",
      "idp_version" : "v3",
      "icon" : "tool",
      "enable" : true,
      "visible" : false,
      "api" : `https://${this.appConfig.serverHost}/dev-fwa-generic/idp/get_classification`
    },
    {
      "name" : "Version 4",
      "key" : "IDPV4",
      "idp_version" : "v4",
      "icon" : "tool",
      "enable" : true,
      "visible" : false,
      "api" : `https://${this.appConfig.serverHost}/dev-fwa-generic/idp/get_classification`
    }
  ]
 
  OCROptions = [
    {
      value: 'INITIATEIDP',
      label: 'No Touch Auto Flow',
      disabled: false,
      isLeaf: true
    },
    {
      value: 'IDPV3',
      label: 'Human-in-Loop Assist',
      disabled: false,
      isLeaf: true,
      children: [
        // {
        //   value: 'IDPV2',
        //   label: 'Version 2',
        //   isLeaf: true,
        //   children: []
        // },
        // {
        //   value: 'IDPV3',
        //   label: 'Version 3',
        //   isLeaf: true,
        //   children: []
        // },
        // {
        //   value: 'IDPV4',
        //   label: 'Version 4',
        //   isLeaf: true,
        //   children: []
        // }
      ]
    }
  ]
  nzOptions: NzCascaderOption[] = this.OCROptions;
  moreDetails = [
    {
      "name" : "Audit",
      "key" : "AUDIT",
      "icon" : "audit",
      "enable" : true,
      "api" : `https://${this.appConfig.serverHost}/dev-fwa-generic/idp/${this.idp_guid}/audit`
    },
    {
      "name" : "Summary",
      "key" : "SUMMARY",
      "icon" : "solution",
      "enable" : true,
      "api" : `https://${this.appConfig.serverHost}/dev-fwa-generic/idp/initiate_idp`
    },
    {
      "name" : "Cancel IDP",
      "key" : "CANCEL",
      "icon" : "close-square",
      "enable" : true,
      "api" : `https://${this.appConfig.serverHost}/dev-fwa-generic/idp/get_classification`
    }
  ]
  steps = [
    {
      id: 1,
      title: "Document Upload",
      desc: "Upload documents in various formats, including PDF, images or Zip File (for multiple images/pdf), to begin processing.",
      element: 'upload',
      status: 'process'
    },
    {
      id: 2,
      title: "Review Document Classification",
      desc: "Verify and refine the automated classification of documents, adding details to guide type-specific extraction processes.",
      element: 'classification',
      status: 'wait'
    },
    {
      id: 3,
      title: "Review Document Interpretation",
      desc: "Check and confirm the accuracy of data extracted via OCR and AI technologies, making corrections as needed.",
      element: 'interpretation',
      status: 'wait'
    },
    {
      id: 4,
      title: "Finalize Stage",
      desc: "Displays the processing status, highlights completion, identifies any errors, and outlines subsequent action items.",
      element: 'status',
      status: 'wait'
    },
  ]

  classificationActions = [
    {
      "actionKey" : "PROCCED",
      "label" : "Save & Proceed"
    },
    {
      "action" : "CANCEL_IDP",
      "label" : "Cancel IDP"
    }
  ]
// "CLAIM_FORM", "DEATH_CERTIFICATE"

documentClassifiedAsOptions = [
  {
    "lookupKey" : "PROPOSAL_FORM",
    "lookupValue" : "Proposal Form"
  },
  {
    "lookupKey" : "FINANCIAL_DOCUMENT",
    "lookupValue" : "Financial Document"
  },
  {
    "lookupKey": "KYC_DOCUMENT",
    "lookupValue": "KYC Document"
  },
  {
    "lookupKey": "MEDICAL_REPORT",
    "lookupValue": "Medical Report"
  },
  {
    "lookupKey": "OTHER",
    "lookupValue": "Other"
  }
]

  // reject reason lookup WRONGDOCUMENT = Wrong Document, UNSUPPORTEDFILETYPE = Unsupported File Type, PAGELIMITBREACHED = Page Limit Breached
  documentRejectCategories = [
    {
      "lookupKey" : "WRONGDOCUMENT",
      "lookupValue" : "Wrong Document"
    },
    {
      "lookupKey" : "UNSUPPORTEDFILETYPE",
      "lookupValue" : "Unsupported File Type"
    },
    {
      "lookupKey" : "PAGELIMITBREACHED",
      "lookupValue" : "Page Limit Breached"
    }
  ]
  rejectionReasons = [
    { lookupKey: "INVALID_EXTRACTION", lookupValue: "Invalid Extraction" },
   { lookupKey: "MISINTERPRETATION_OF_DATA", lookupValue: "Misinterpretation of Data" },
    { lookupKey: "DATA_FORMAT_ISSUES", lookupValue: "Data Format Issues" },
    { lookupKey: "LOW_CONFIDENCE_SCORE", lookupValue: "Low Confidence Score" },
    { lookupKey: "VALIDATION_ERRORS", lookupValue: "Validation Errors" },
    { lookupKey: "HANDWRITING_ISSUES", lookupValue: "Handwriting Issues" },
    { lookupKey: "LAYOUT_DETECTION_ERRORS", lookupValue: "Layout Detection Errors" },
    { lookupKey: "TABLE_EXTRACTION_ERRORS", lookupValue: "Table Extraction Errors" }
  ];
  stepCurrent = 1
  stepCurrentStatus = "wait"
  stepIndexChange(i){
    if (this.stepCurrent !== i) this.stepCurrent = i+1;
    console.log("Steps = ", this.steps)
  }
  pre(): void {
    this.stepCurrent -= 1;
    this.stepCurrentStatus = this.steps[this.stepCurrent-1].status 
  }

  next(): void {
    this.stepCurrent = this.stepCurrent+1;
    this.stepCurrentStatus = this.steps[this.stepCurrent-1].status 
  }
  currentWorkflowCd = 'LIFEINTIMATION';   // First part
  currentCompanyCd = 'SunLife_PH';    // Second part
  currentCountryCd = 'PH'; 
  currentMode = {}
  fileUploadEndpoint: string;
  fileFetchEndpointRAW: string;
  fileFetchEndpoint: string;
  showJsonEditor : boolean = false;
  isCollapsed = []
  enableOCRModeSelect : boolean = false;
  enableOCRModeCascader : boolean = true;
  enableNewOCROption : boolean = false;
  ocrGeneratedClaimNo: string;
  isOCRFailed: boolean = false;
  ocrFailedErrorMsg = "Oops! Something went wrong on our end. Our team is already on it, and we'll have things back up and running smoothly as soon as possible. Thank you for your patience.";
  errorRespMsg: string;
  errorTitleMsg : string = "Unable to process request"
  intimationGuid = null;
  extractionJSON = null;
  showOCRExtractionResult : boolean = false;
  showIDPV2RespCard : boolean = false
  documentClassification : any = [];
  documentClassificationOriginal : any = [];
  request_id = null;
  idp_summary : string = ""
  documentInterpretationResp = null;
  originalInterpretationResp = {}
  interpretationSectionsJSON = {}
  interpretationSaveDisabled : boolean = false
  documentInterpretationFinalize = null;
  interpretationDecision : string = "ACCEPT";
  rejectReasonCategory : string = null;
  rejectReason : string = null
  finalStatus : string = ""
  intimationNumber : string = null
  proposalNum : string = null
  successResultSubTitle : string = null;
  enableRejectReason : boolean = false;
  redirectBackTo: string;
  navigation;
  showIDPV2PasswordModal : boolean = false; 
  inputType: string = "password";
  capturedPassword : string = "";
  showIDPSummaryModal : boolean = false;;
  showIDPAuditModal : boolean = false;
  previewDataStream
  previewDocumentDO
  previewFileUrl
  modalFilePreview
  fileIsBeingDownloaded
  previewDataStreamUnsanitized
  documentName = ""
  documentPreview = {}
  draggableBoxesforDocument = []
  enableDraggableBox : boolean = false;
  documentDetectionSuccess = false;
  documentDetectionResponse: any;
  documentDetectionMsg = null;
  processingOCR: boolean = false;
  allowedSections = [
    'PolicyDetails',
    'ListOfClients',
    'EventDetails',
    'HospitalizationDetails',
    'MedicalDetails'
  ];
  notAllowedSections = [
    'statusCd',
    'integrityCheckIssues',
    'validationExceptions',
    'interpretationSummary',
    'ValidationExceptions',
    'InterpretationSummary',
    'IntegrityCheckIssues'
  ];
lookupsToBindApis = [
  {
    "key" : "documentClassification",
    "api" : `https://${this.appConfig.serverHost}/dev-fwa-generic/idp/LIFEINTIMATION/workflow_lookup`,
    "lookupStorage" : "documentClassifiedAsLookup"
  }
]
encryptionKey = 'your-secret-key';
lookups = []
workflowStageCd = null;
intakeData = null
IO = null;
intakeNum = null;
intakeGuid = null;
failSubTitle = "";
showCancelIDPStep : boolean = false;
texts: string[] = [
  'Double-check for any password-protected files. Ensure all documents are accessible to avoid delays/errors in processing.',
  'Use the supported document formats (e.g., PDF, JPG, PNG, and TIFF or a Zip file of Multiple supported Documents) for best compatibility and extraction results.',
  'Remove any unnecessary or blank pages from your documents to enhance focus on relevant content and speed up processing.',
  'Check your internet connection before starting the upload process to prevent interruptions and ensure a smooth document submission. Remember the speed of Internet might affect OCR upload performance.',
  'Relevant names to files, help the system to handle documents better. This can help improve the classification step and accuracy.',
  'Preview your uploaded documents if possible, to catch any scan errors or issues before Finalize stage.',
  'For scanned images, better brightness and contrast settings helps ensure text is distinct from the background, which eventually enhances OCR accuracy.',
  "Familiarize yourself with the system's error messages to resolve common issues quickly during processing."
];
currentIndex = 0;
currentText = this.texts[this.currentIndex];
isVisible = false;
timeoutId: any;
enableCarouselFeature : boolean = true;
classificationRectificationRemark : string = null;
interpretationRectificationRemark : string = null;
interpretation_metrics = {};
interpretationMetaData = {};
entityDocumentDO = [];
  ngOnInit(): void {
    this.fetchIDPConfigurations();
    this.intializeOCRTransaction();
    console.log(this.configData);
    this.fileUploadEndpoint = this.appConfig.baseApiPath + `${environment.mono? environment.monoMasterTokenServerContext: 'master-service'}/document/saveMultipart`;
    this.fileFetchEndpointRAW = `${environment.mono? environment.monoMasterTokenServerContext: 'master-service'}/document/fetchMultipart`;
    this.fileFetchEndpoint = this.appConfig.baseApiPath + this.fileFetchEndpointRAW;
    this.fetchLookups();
  }

  ngOnDestroy(){
      this.currentMode = {};
      this.isOCRFailed= false;
      this.ocrGeneratedClaimNo = null;
      this.showOCRExtractionResult = null;
      this.showIDPV2RespCard = null;
      this.interactService.ocrTransactionSubject$.next(null);
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.stopFunction();
  }
  intializeOCRTransaction(){
      this.currentMode = {};
      this.isOCRFailed= false;
      this.ocrGeneratedClaimNo = null;
      this.showOCRExtractionResult = null;
      this.showIDPV2RespCard = null;
      this.stepCurrent = 1;
    this.interactService.ocrTransactionSubject$.pipe(take(1)).subscribe(res => {
      if(res && res['IO'] && res['state']){
        this.workflowStageCd = res['state'] ? res['state'] : null;
        this.IO = res['IO'] ? res['IO'] : null;
        this.OCRModes.forEach(mode=>{
            if(this.IO && this.IO.intakeDO && this.IO.intakeDO.idp_version && mode.idp_version == this.IO.intakeDO.idp_version)
              this.currentMode = mode;
            else this.currentMode = this.OCRModes[4];
        })
        // this.currentModeKey =  `Human in Loop- ${this.currentMode['name']}`;
        this.currentModeKey =  `Human-in-Loop Assist`;
        this.transformIO();
      }
    })
  }
  showRejectMsg = ""
  enableRejectInfo = false;
  transformIO(){
    if(this.IO && this.IO.intakeDO && this.workflowStageCd){ 
      this.isOCRFailed= false;
      this.ocrGeneratedClaimNo = null;
      this.showOCRExtractionResult = null;
      this.showIDPV2RespCard = null;
      this.enableOCRModeCascader = false;
      this.enableNewOCROption = true;
      if(this.workflowStageCd == "PEDING_DOCUMENT_CLASSIFICATION" || this.workflowStageCd == "PENDING_DOCUMENT_CLASSIFICATION"){
        this.showIDPV2RespCard = true;
        let data = this.commonUtility.deepCopy(JSON.parse(this.IO.intakeDO.processOutput));
        if(data){
          this.stopFunction();
          this.showAsyncFlowStatus = false;
          this.intakeData = this.commonUtility.deepCopy(data);
          if(this.intakeData && Object.keys(this.intakeData )){
            this.documentClassification = this.intakeData.documentClassification ? this.intakeData.documentClassification : [];
            this.idp_summary = this.intakeData['idp_summary'] ? this.intakeData['idp_summary'] : "";
            this.classificationRectificationRemark = this.intakeData['document_classification_hil_remark'] ? this.intakeData['document_classification_hil_remark'] : "";
            this.documentClassificationOriginal = this.commonUtility.deepCopy(this.documentClassification)
            this.idp_guid = this.intakeData.idp_guid ? this.intakeData.idp_guid : null;
            this.request_id = this.intakeData.request_id ? this.intakeData.request_id : null;
            this.intakeNum = this.IO.intakeDO.intakeReqNum;
            this.showIDPV2RespCard = true;
            this.isOCRFailed = false;
            this.steps[0].status = "finish"
            this.stepCurrent = 2;
            this.steps[this.stepCurrent-1].status = "process";
            this.viewAudit();
          }
          else { 
            this.isOCRFailed = true;
            this.processingOCR = false;
          }
        }
        else{
          this.isOCRFailed = true;
          this.processingOCR = false; 
        }
      }
      else if(this.workflowStageCd == "PENDING_DOCUMENT_INTERPRETATION"){
        let data = this.commonUtility.deepCopy(JSON.parse(this.IO.intakeDO.processOutput));
        if(data){
          this.intakeData = this.commonUtility.deepCopy(data);
          if(this.intakeData && Object.keys(this.intakeData )){
            this.documentClassification = this.intakeData.documentClassification ? this.intakeData.documentClassification : [];
            this.idp_summary = this.intakeData['idp_summary'] ? this.intakeData['idp_summary'] : "";
            this.classificationRectificationRemark = this.intakeData['document_classification_hil_remark'] ? this.intakeData['document_classification_hil_remark'] : "";
            this.documentClassificationOriginal = this.commonUtility.deepCopy(this.documentClassification)
            this.documentInterpretationResp =  this.intakeData;
            this.originalInterpretationResp = this.commonUtility.deepCopy(this.intakeData);
            this.intakeNum = this.IO.intakeDO.intakeReqNum;
            this.idp_guid = this.intakeData.idp_guid ? this.intakeData.idp_guid : null;
            this.interpretationMetaData = this.intakeData['extractionResult'] ? this.intakeData['extractionResult']['interpreted_meta_data'] ? this.intakeData['extractionResult']['interpreted_meta_data'] : null :null
            this.jsonTransformFunctionForViewSummary(this.documentInterpretationResp);
            this.interpretation_metrics = this.intakeData['extractionResult']['metrics'] ? this.intakeData['extractionResult']['metrics'] : null;
            if(this.interpretation_metrics && Object.keys(this.interpretation_metrics))
             this.setConfigForInterpretationMetrics();
            this.showIDPV2RespCard = true;
            this.steps[0].status = "finish"
            this.steps[1].status = "finish"
            this.stepCurrent = 3;
            this.steps[this.stepCurrent-1].status = "process";  
            this.processingOCR = false;  
            this.viewAudit();
          }
          else{
            this.isOCRFailed = true;
            this.processingOCR = false; 
          }
        }
        else{
          this.isOCRFailed = true;
          this.processingOCR = false; 
        }
      }
      else if(this.workflowStageCd == "IDP_APPROVED"){
        let data = this.commonUtility.deepCopy(JSON.parse(this.IO.intakeDO.processOutput));
        if(data){
          this.intakeData = this.commonUtility.deepCopy(data);
          if(this.intakeData && Object.keys(this.intakeData )){
            this.documentClassification = this.intakeData.documentClassification ? this.intakeData.documentClassification : [];
            this.idp_summary = this.intakeData['idp_summary'] ? this.intakeData['idp_summary'] : "";
            this.classificationRectificationRemark = this.intakeData['document_classification_hil_remark'] ? this.intakeData['document_classification_hil_remark'] : "";
            this.documentClassificationOriginal = this.commonUtility.deepCopy(this.documentClassification)
            this.documentInterpretationResp =  this.intakeData;
            this.originalInterpretationResp = this.commonUtility.deepCopy(this.intakeData);
            this.intakeNum = this.IO.intakeDO.intakeReqNum;
            this.idp_guid = this.intakeData.idp_guid ? this.intakeData.idp_guid : null;
            this.interpretationMetaData = this.intakeData['extractionResult'] ? this.intakeData['extractionResult']['interpreted_meta_data'] ? this.intakeData['extractionResult']['interpreted_meta_data'] : null :null
            this.jsonTransformFunctionForViewSummary(this.documentInterpretationResp);
            this.interpretation_metrics = this.intakeData['extractionResult']['metrics'] ? this.intakeData['extractionResult']['metrics'] : null;
            if(this.interpretation_metrics && Object.keys(this.interpretation_metrics))
             this.setConfigForInterpretationMetrics();

            this.documentInterpretationFinalize =  this.intakeData;
            this.interpretationRectificationRemark = this.IO.intakeDO['interpretationRemark'] ? this.IO.intakeDO['interpretationRemark'] : "";
            if(this.intakeData['overall_status'] && this.IO.intakeDO['intakeIntimationRefNum'] && this.IO.intakeDO['entityRefNum']){
              this.finalStatus =  this.intakeData['overall_status'];
              // this.intimationNumber = this.IO.intakeDO['intakeIntimationRefNum'] ? this.IO.intakeDO['intakeIntimationRefNum'] : null
              this.proposalNum = this.IO.intakeDO['intakeIntimationRefNum'] ? this.IO.intakeDO['intakeIntimationRefNum'] : null
              this.intimationGuid = this.IO.intakeDO['entityRefNum'] ? this.IO.intakeDO['entityRefNum'] : null
              this.stopFunction();
              this.showAsyncFlowStatus = false;
            }
            this.workflowStageCd = this.IO.intakeDO['stageCd'] ? this.IO.intakeDO['stageCd']  : null;
            this.successResultSubTitle = `Proposal created with number : ${this.proposalNum}`;
            // this.successResultSubTitle = `Proposal created with number : ${this.proposalNum}`;
            this.successResultSubTitle = `Proposal created${this.proposalNum ? ' with number : ' + this.proposalNum : ''}`;
            this.failSubTitle =  this.proposalNum ? "" : `Intake Number is ${this.intakeNum}`;
            this.showIDPV2RespCard = true;
            this.steps[0].status = "finish"
            this.steps[1].status = "finish"
            this.steps[2].status = "finish"
            this.stepCurrent = 4;
            this.steps[this.stepCurrent-1].status = "process";  
            this.processingOCR = false; 
            this.viewAudit();
          }
          else{
              this.isOCRFailed = true;
              this.processingOCR = false; 
          }
        }
        else{
          this.isOCRFailed = true;
          this.processingOCR = false; 
        }
      }
      else if(this.workflowStageCd == "REJECT"){
        let data = this.commonUtility.deepCopy(JSON.parse(this.IO.intakeDO.processOutput));
        if(data){
            this.intakeData = this.commonUtility.deepCopy(data);
            this.documentClassification = this.intakeData.documentClassification ? this.intakeData.documentClassification : [];
            this.idp_summary = this.intakeData['idp_summary'] ? this.intakeData['idp_summary'] : "";
            this.classificationRectificationRemark = this.intakeData['document_classification_hil_remark'] ? this.intakeData['document_classification_hil_remark'] : "";
            this.documentClassificationOriginal = this.commonUtility.deepCopy(this.documentClassification)
            this.documentInterpretationResp =  this.intakeData;
            this.originalInterpretationResp = this.commonUtility.deepCopy(this.intakeData);
            this.intakeNum = this.IO.intakeDO.intakeReqNum;
            this.idp_guid = this.intakeData.idp_guid ? this.intakeData.idp_guid : null;
            this.interpretationMetaData = this.intakeData['extractionResult'] ? this.intakeData['extractionResult']['interpreted_meta_data'] ? this.intakeData['extractionResult']['interpreted_meta_data'] : null :null
            this.jsonTransformFunctionForViewSummary(this.documentInterpretationResp);
            this.interpretation_metrics = this.intakeData['extractionResult']['metrics'] ? this.intakeData['extractionResult']['metrics'] : null;
            if(this.interpretation_metrics && Object.keys(this.interpretation_metrics))
             this.setConfigForInterpretationMetrics();
            this.enableRejectInfo = true;
            this.showRejectMsg =  `Intake number ${this.IO.intakeDO.intakeReqNum} is rejected.`;
            this.rejectReason = this.IO.intakeDO.rejectionReason;
            this.rejectReasonCategory = this.IO.intakeDO.rejectionReasonCategoryCd;
            this.steps[0].status = "finish"
            this.steps[1].status = "finish"
            this.steps[2].status = "finish"
            this.stepCurrent = 4;
            this.steps[this.stepCurrent-1].status = "process"; 
            this.isOCRFailed = false;
            this.processingOCR = false;
        }
        else { 
          this.isOCRFailed = true;
          this.processingOCR = false;
        }
      }
      else if(this.workflowStageCd == "DOCUMENT_CLASSIFICATION_CANCELLED"){
        let data = this.commonUtility.deepCopy(JSON.parse(this.IO.intakeDO.processOutput));
        if(data){
          this.stopFunction();
          this.showAsyncFlowStatus = false;
          this.intakeData = this.commonUtility.deepCopy(data);
          if(this.intakeData && Object.keys(this.intakeData )){
            this.intakeNum = this.IO.intakeDO.intakeReqNum;
            this.documentClassification = this.intakeData.documentClassification ? this.intakeData.documentClassification : [];
            this.idp_summary = this.intakeData['idp_summary'] ? this.intakeData['idp_summary'] : "";
            this.idp_guid = this.intakeData.idp_guid ? this.intakeData.idp_guid : null;
            this.documentClassificationOriginal = this.commonUtility.deepCopy(this.documentClassification)
            this.idp_guid = this.intakeData.idp_guid ? this.intakeData.idp_guid : null;
            this.request_id = this.intakeData.request_id ? this.intakeData.request_id : null;
            this.isOCRFailed = false;
            this.showIDPV2RespCard = true;
            this.finalStatus =  this.intakeData['overall_status'];
            this.steps[0].status = "finish"
            this.steps[1].status = "finish"
            this.steps[2].status = "error"
            this.steps[3].status = "process"
            this.showCancelIDPStep = true;
            this.stepCurrent = 4;
            this.viewAudit();
            this.failSubTitle = `Intake Number ${this.intakeNum} canceled.`
          }
          else{
              this.isOCRFailed = true;
              this.processingOCR = false; 
          }
        }
        else{
          this.isOCRFailed = true;
          this.processingOCR = false; 
        }
      }
    }
  }

  fetchLookups(){
    const headers = { 'Content-Type': 'application/json' ,'Authorization' : this.apiRequestService.token};
    if(this.lookupsToBindApis && this.commonUtility.isArrayIterable(this.lookupsToBindApis)){
      this.lookupsToBindApis.forEach(lookup =>{
        if(lookup.api){
          this.http.get<any>(lookup.api, { headers }).subscribe(resp => {
            this.documentClassifiedAsOptions = resp;
          })
        }
      })
    }
  }
  configurationLookup = []
  selectedConfiguration = "LIFEINTIMATION-SunLife_VN-VN"
  fetchIDPConfigurations(){
    const headers = { 'Content-Type': 'application/json' ,'Authorization' : this.apiRequestService.token};
    let url = `https://${this.appConfig.serverHost}/dev-fwa-generic/idp/get_idp_config_lookup/`
    this.http.get<any>(url, { headers }).subscribe(resp => {
      if(resp && resp.lookup_list)
      this.configurationLookup = resp.lookup_list;
    })
  }
  setConfigurations() {
    try {
      if (this.selectedConfiguration) {
        // Split the string by '-'
        const parts = this.selectedConfiguration.split('-');
  
        // Check if there are enough parts
        if (parts.length < 3) {
          throw new Error('Invalid configuration format. Expected at least three parts separated by "-"');
        }
  
        // Assign values safely
        this.currentWorkflowCd = parts[0] || '';   // First part
        this.currentCompanyCd = parts[1] || '';    // Second part
        this.currentCountryCd = parts[2] || '';    // Third part
      } else {
        throw new Error('No configuration selected.');
      }
    } catch (error) {
      console.error('Error in setConfigurations:', error.message);
    }
  }
  
  ocrLoaderMsg = {}

   /* Error Panel */
   errPanelOpen: boolean = false;
   errPanelCollapsed: boolean = false;
   errDetailsPanel(state) { this.errPanelOpen = !!state }
   errorPanelToggle() {
     //Expand/collapse visible error panel
     this.errPanelCollapsed = !this.errPanelCollapsed;
   }
   exceptionPanelOpen = false;
   exceptionPanel(status) { this.exceptionPanelOpen = !!status }

  currentTimeouts = [];
  pseudoLoad(t = 0) {
    this.processingOCR = true;
    this.ocrLoaderMsg = {}; // Reset the loader message for each API call
    let totalFakeLoadTime = t || 51250;
    let currentStepLoaderMessages = this.loaderMsges[this.steps[this.stepCurrent - 1].element];

    // Clear any existing timeouts to prevent carryover
    if (this.currentTimeouts && this.currentTimeouts.length > 0) {
        this.currentTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
    }
    this.currentTimeouts = []; // Reset the timeout tracker

    if (currentStepLoaderMessages && currentStepLoaderMessages.length) {
        let divisions = currentStepLoaderMessages.length;
        
        // Display the first message immediately
        this.ocrLoaderMsg = {
            "title": currentStepLoaderMessages[0].title,
            "description": currentStepLoaderMessages[0].description
        };

        // Show the remaining messages with a delay
        currentStepLoaderMessages.forEach((msg, i) => {
            if (i > 0) { // Skip the first message since it's already shown
                const timeoutId = setTimeout(() => {
                    this.ocrLoaderMsg = {
                        "title": msg.title,
                        "description": msg.description
                    };
                }, ~~(totalFakeLoadTime / divisions) * i); // Adjusted to ensure the first message is immediate
                this.currentTimeouts.push(timeoutId); // Track the timeout ID
            }
        });
    }
}



  // Define a list of MIME types for ZIP files
  zipMimeTypes: string[] = [
    'application/zip',
    'application/x-zip-compressed',
    'application/octet-stream',
    'application/pdf',
    'image/jpeg' // Use cautiously as it's very generic
  ];

  setOCRMode(selectedMode){
    // if(selectedMode && selectedMode.key && selectedMode.key != "IDPV2"){
      this.resetAllFlags();
      if(selectedMode && selectedMode.key){
        this.currentMode = selectedMode;
        this.startCarousel();
      }
    if(selectedMode && this.commonUtility.isArrayIterable(selectedMode) && selectedMode.length){
      if(selectedMode.length>1 || (selectedMode.length && selectedMode[0]=='IDPV3')){
        this.currentMode['name'] = selectedMode[0]
        if(selectedMode > 1)
        this.currentMode['key'] = selectedMode[1] 
        else this.currentMode['key'] = selectedMode[0]
        this.OCRModes.forEach(o=>{
          if(o.key == selectedMode[1] || o.key == selectedMode[0]) {
            // this.currentModeKey =  `Human in Loop - ${o.name}`;
            this.currentModeKey =  `Human-in-Loop Assist`
            this.currentMode['api'] = o.api;
          }
        })
      }
      else{
        this.currentMode['name'] = selectedMode[0]
        this.currentMode['key'] = selectedMode[0]
        this.currentModeKey =  `No Touch Auto Flow`;
        this.OCRModes.forEach(o=>{
          if(o.key == selectedMode[0]) {
            this.currentMode['api'] = o.api;
          }
        })
      }
      this.startCarousel();
    }
  }
  resetAllFlags(){
    this.currentMode = {};
    this.isOCRFailed= false;
    this.finalStatus = null;
    this.ocrGeneratedClaimNo = null;
    this.showOCRExtractionResult = null;
    this.showIDPV2RespCard = null;
    this.startCarousel();
    this.rejectReason = null;
    this.cancelReason = null;
    this.finalStatus = null;
    this.IO = null; 
  }
  createNewProcess(){
   this.resetAllFlags();
  }
  uploadNewDocument(){
      this.isOCRFailed= false;
      this.finalStatus = null;
      this.ocrGeneratedClaimNo = null;
      this.showOCRExtractionResult = null;
      this.showIDPV2RespCard = null;
      this.enableNewOCROption = false;
      this.enableOCRModeCascader = true;
      this.intakeNum = null;
      this.workflowStageCd = null;
      // this.currentMode = {};
      // this.resetAllFlags();
      this.stepCurrent = 1;
      this.steps.forEach(step =>{
        if(step.element != 'upload') step.status = "wait"
        else step.status = 'process'
      })
  }

  cancelCurrentUpload(){

  }

  retry(){
    this.isOCRFailed= false;
    this.enableOCRModeCascader = true;
    this.enableNewOCROption = false;
    this.idp_summary = null
  }
  // Function to check if a given MIME type is a ZIP file
  isZipMimeType(mimeType: string): boolean {
    return this.zipMimeTypes.includes(mimeType);
  }

  fileUploadBefore = (file: NzUploadFile, fileList): boolean => {
    this.preUploadImgChecks(file).subscribe(
      n => {
        if (n) { //n = true => All passed
          //this.fileListTemp = []; //reset
          //this.fileListTemp.push(file); //push
          this.OCRFileUpload(file);
          return true;
        }
        else{
          return true;
        }
      },
      e => { console.log(e) },
      () => { }
    );
    return true;
  };

  preUploadImgChecks = (file: NzUploadFile) => {
    return new Observable((observer: Observer<boolean>) => {
      let isFileTypeSupported: Boolean = this.isZipMimeType(file.type);
      if (!isFileTypeSupported) {
        this.msg.warning(`Uploaded filetype is not supported. Please upload the file with supported format.`,{nzDuration : 1500});
        setTimeout(() => { observer.complete();; }, 300); 
        return;
      }

      const fileSizeOK: boolean = file.size / 1024 / 1024 < this.allowedFileSize;
      if (!fileSizeOK) {
        this.msg.warning(`Uploaded file must be smaller than ${this.allowedFileSize} MB`,{nzDuration : 1500});
        setTimeout(() => { observer.complete();; }, 300); 
        return;
      }
      observer.next(isFileTypeSupported && fileSizeOK);
      observer.complete();
      return;
    });
  };
  showRefreshButton = false
  asyncWait(){
    this.showRefreshButton = true;
    this.startFunctionEvery30Seconds(() => {
      this.fetchAsyncTransaction();
    });
  }
  startFunctionEvery30Seconds(callback: () => void): void {
    if (typeof callback !== 'function') {
      throw new Error('The argument must be a function');
    }

    // Call the function initially
    // callback();

    // Set an interval to call the function every 30 seconds
    // this.intervalId = setInterval(() => {
    //   this.callCount++;
    //   if (this.callCount >= this.maxCalls) {
    //     this.stopFunction(); // Stop after 4 calls
    //   } else {
    //     callback();
    //   }
    // }, 45000);

    // Delay the first call by 30 seconds
    this.timeoutId = setTimeout(() => {
      callback();
      this.callCount++;

      // Set up subsequent calls every 45 seconds
      this.intervalId = setInterval(() => {
        this.callCount++;
        if (this.callCount >= this.maxCalls) {
          this.stopFunction(); // Stop after 4 calls
        } else {
          callback();
        }
      }, 45000); // 45 seconds
    }, 30000); // 30 seconds
  }
  callCount: number = 0;
  maxCalls: number = 4;
  stopFunction(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  fetchAsyncTransaction(): void {
    // this.stopFunction();
    let fetchURL = `intakeFetchByGuid/${this.intakeGuid}`
    let transactionDataIO: any = [];
    let pathVariable = []
    pathVariable.push(this.intakeGuid)
    this.apiRequestService.getCallWithAPIMapper(fetchURL).subscribe(resp => {
      if (resp && Object.keys(resp).length && resp.intakeDO && resp.intakeDO.processOutput) {
        this.workflowStageCd = resp.intakeDO['stageCd'] ? resp.intakeDO['stageCd'] : null;
        this.IO = resp;
        this.currentMode = this.OCRModes[5];
        this.transformIO();
        // this.stopFunction();
        // this.showAsyncFlowStatus = false;
            // this.interactService.sendIOToOCRTransaction(data.stageCd,transactionDataIO, inboxType)
      }
    });
  }

  enableAutoRefreshMode(){

  }

  _UIErrorList = [];
  showAsyncFlowStatus : boolean = false;
  asyncMSGTitle : string;
  OCRFileUpload(file) {
    this.pseudoLoad(0);
    let base64OCR = null;
    let url = ""
    if(this.currentMode && this.currentMode['api']){
      this.claimOCR_URL = this.currentMode['api'];
      url = this.currentMode['api'];
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {

      base64OCR = reader.result;
      let request = {
        "product_type":"IDP",
        "module_name":"OCR",
        "business_process":"FWARISKANALYSIS",
        "workflowCd":this.currentWorkflowCd,  // will changed based on LOB
        "source" : "OCR",
        "companyCd":this.currentCompanyCd,
        "countryCd":this.currentCountryCd,
        "output_lang": "",
        "AUTH_TOKEN": this.apiRequestService.token,
        "idp_guid": this.idp_guid,
        "request_id": this.request_id,
        "documentClassification": null,
        "document_classification": null,
        "document_classification_hil_decisionCd": null,
        "document_classification_hil_remark" : null,
        "interpreted_information": null,
        "interpreted_HIL_decisionCd": null,
        "interpreted_hil_remark" : null,
        "fileName" : file ? file.name ? file.name : null : null,
      }

      if(this.currentMode && this.currentMode['key'] == "IDPV1") {
        request['file'] = base64OCR;
        request['idp_version'] = "v1";
      }
      if(this.currentMode && this.currentMode['key'] == "IDPV2" || this.currentMode['key'] == "INITIATEIDP") {
        request['base64'] = base64OCR;
        request['idp_version'] = "v2";
      }
     
      if(this.currentMode && this.currentMode['key'] == "EXTRACTIONTESTING") request['base64'] = base64OCR

      const headers = { 'Content-Type': 'application/json' ,'Authorization' : this.apiRequestService.token};
      if(this.currentMode && (this.currentMode['key'] == "IDPV1" || this.currentMode['key'] == "IDPV2" || this.currentMode['key']=='INITIATEIDP')){
        this.http.post<any>(url, request, { headers }).subscribe(resp => {
          this.processingOCR = false;
          this.enableOCRModeCascader = false;
          this.enableNewOCROption = true;
          if (this.currentMode['key']=="IDPV1" && resp && resp.claimIntimationNo) {
            this.ocrGeneratedClaimNo = resp['claimIntimationNo'];
            this.intimationGuid = resp['guid'];
            this.isOCRFailed = false;
            this.errorRespMsg = null;
          } 
          else if (this.currentMode['key']=="INITIATEIDP" && resp) {
            this.finalStatus = resp['overall_status'] ?  resp['overall_status'] : null;
            this.idp_summary = resp['idp_summary'] ? resp['idp_summary'] : null
            this.isOCRFailed = false;
            this.errorRespMsg = null;
          } 
          else if(this.currentMode['key']=="IDPV2" && resp){
            //TODO
            this.showIDPV2RespCard = true;
            this.documentClassification = resp.documentClassification ? resp.documentClassification : [];
            this.idp_summary = resp['idp_summary'] ? resp['idp_summary'] : this.idp_summary
            this.documentClassificationOriginal = this.commonUtility.deepCopy(this.documentClassification)
            this.idp_guid = resp.idp_guid ? resp.idp_guid : null;
            this.request_id = resp.request_id ? resp.request_id : null;
            this.isOCRFailed = false;
            this.steps[this.stepCurrent-1].status = "finish"
            this.stepCurrent = 2;
            this.steps[this.stepCurrent-1].status = "process";
            this.viewAudit();
          }
          else if(this.currentMode['key']=="EXTRACTIONTESTING" && resp && resp['extractionResult']){
            this.showOCRExtractionResult = true;
            this.extractionJSON = resp['extractionResult']['output'] ? resp['extractionResult']['output'] : null;
            this.isOCRFailed = false;
          }
          else if(resp && resp.Error){
            this.errorRespMsg = resp.Error;
            this.ocrGeneratedClaimNo = null;
            this.isOCRFailed = true;
          }else {
            this.ocrGeneratedClaimNo = null;
            this.isOCRFailed = true;
            this.errorRespMsg = null;
          }
        }, e => {
          this.processingOCR = false;
          this.enableOCRModeCascader = false;
          this.enableNewOCROption = true;
          this.isOCRFailed = true;
          this.ocrGeneratedClaimNo = null;
          this.errorRespMsg = null;
        });
      }
      else if(this.currentMode && this.currentMode['key'] == "IDPV3"){
        let payload = {
        "fileName" : file ? file.name ? file.name : null : null,
         "intakeDO": {
            "componentGuid": this.idp_guid,
            "componentIdNum":this.request_id,
            "componentCd": "OCR",
            "additionalField1": this.currentWorkflowCd,
            'additionalField2' : this.currentCompanyCd,
            'additionalField3' : this.currentCountryCd,
            "intakeDocumentBase64": base64OCR,
            "processOutput": null,
            "intakeReqNum": this.intakeNum,
            "entityRefNum": null,
            "baseProductFamilyCd":"LIFE",
            'idp_version' : "v3",
          },
        }
        this.apiRequestService.postCallWithAPIMapper('proposalIntakeSave', payload).subscribe(resp =>{
          this.processingOCR = false;
          this.enableOCRModeCascader = false;
          this.enableNewOCROption = true;
          this.IO = resp;
          if(resp && !resp.Error && resp.intakeDO){
            //TODO
            this.showIDPV2RespCard = true;
            let data = this.commonUtility.deepCopy(JSON.parse(resp.intakeDO.processOutput));
            if(data){
              this.intakeData = this.commonUtility.deepCopy(data);
              if(this.intakeData && Object.keys(this.intakeData )){
                this.documentClassification = this.intakeData.documentClassification ? this.intakeData.documentClassification : [];
                this.entityDocumentDO = resp['entityDocumentDOs'] ? resp['entityDocumentDOs']  : []
                this.setDocumentImageURL();
                this.idp_summary = this.intakeData['idp_summary'] ? this.intakeData['idp_summary'] : ""
                this.documentClassificationOriginal = this.commonUtility.deepCopy(this.documentClassification)
                this.idp_guid = this.intakeData.idp_guid ? this.intakeData.idp_guid : null;
                this.intakeNum = resp.intakeDO.intakeReqNum;
                this.workflowStageCd = resp.intakeDO['stageCd'] ? resp.intakeDO['stageCd']  : null;
                this.request_id = this.intakeData.request_id ? this.intakeData.request_id : null;
                this.isOCRFailed = false;
                this.steps[this.stepCurrent-1].status = "finish"
                this.stepCurrent = 2;
                this.steps[this.stepCurrent-1].status = "process";
                this.viewAudit();
              }
              else { 
                this.isOCRFailed = true;
                this.processingOCR = false;
              }
            }
            else { 
              this.isOCRFailed = true;
              this.processingOCR = false;
            } 
          }
          else if(resp && resp.Error){
            this.errorRespMsg = resp.Error;
            this.ocrGeneratedClaimNo = null;
            this.isOCRFailed = true;
          }else {
            this.ocrGeneratedClaimNo = null;
            this.isOCRFailed = true;
            this.errorRespMsg = null;
          }
        }, e => {
          this.processingOCR = false;
          this.enableOCRModeCascader = false;
          this.enableNewOCROption = true;
          this.isOCRFailed = true;
          this.ocrGeneratedClaimNo = null;
          this.errorRespMsg = null;
        })
      }
      else if(this.currentMode && this.currentMode['key'] == "IDPV4"){
        let payload = {
         "transactionMode" : "ASYNC",
         "fileName" : file ? file.name ? file.name : null : null,
         "intakeDO": {
            "componentGuid": this.idp_guid,
            "componentIdNum":this.request_id,
            "componentCd": "OCR",
            "additionalField1": this.currentWorkflowCd,
            'additionalField2' : this.currentCompanyCd,
            'additionalField3' : this.currentCountryCd,
            "intakeDocumentBase64": base64OCR,
            "processOutput": null,
            "intakeReqNum": this.intakeNum,
            "entityRefNum": null,
            "baseProductFamilyCd":"LIFE",
            'idp_version' : "v4"
          }
        }
        this.apiRequestService.postCallWithAPIMapper('proposalIntakeSave', payload).subscribe(resp =>{
          this.processingOCR = false;
          this.enableOCRModeCascader = false;
          this.enableNewOCROption = true;
          this.IO = resp;
          if(resp && !resp.Error && resp.intakeDO){
            //TODO
            
            // let data = this.commonUtility.deepCopy(JSON.parse(resp.intakeDO));
            // if(data){
              // this.intakeData = this.commonUtility.deepCopy(data);
              // if(this.intakeData && Object.keys(this.intakeData )){
                // this.documentClassification = this.intakeData.documentClassification ? this.intakeData.documentClassification : [];
                this.entityDocumentDO = resp['entityDocumentDOs'] ? resp['entityDocumentDOs']  : []
                // this.setDocumentImageURL();
                // this.idp_summary = this.intakeData['idp_summary'] ? this.intakeData['idp_summary'] : ""
                // this.documentClassificationOriginal = this.commonUtility.deepCopy(this.documentClassification)
                // this.idp_guid = this.intakeData.idp_guid ? this.intakeData.idp_guid : null;
                this.intakeGuid = resp.intakeDO.guid;
                this.intakeNum = resp.intakeDO.intakeReqNum;
                this.workflowStageCd = resp.intakeDO['stageCd'] ? resp.intakeDO['stageCd']  : null;
                // this.request_id = this.intakeData.request_id ? this.intakeData.request_id : null;
                this.asyncMSGTitle = `Documents are uploaded successfully! Intake created with ${this.intakeNum}`
                this.isOCRFailed = false;
                this.showAsyncFlowStatus = true;
                this.callCount = 0;
                this.showRefreshButton = false;
                // this.steps[this.stepCurrent-1].status = "finish"
                // this.stepCurrent = 2;
                // this.steps[this.stepCurrent-1].status = "process";
                // this.viewAudit();
              // }
              // else { 
              //   this.isOCRFailed = true;
              //   this.processingOCR = false;
              // }
            // }
            // else { 
            //   this.isOCRFailed = true;
            //   this.processingOCR = false;
            // } 
          }
          else if(resp && resp.Error){
            this.errorRespMsg = resp.Error;
            this.ocrGeneratedClaimNo = null;
            this.isOCRFailed = true;
          }else {
            this.ocrGeneratedClaimNo = null;
            this.isOCRFailed = true;
            this.errorRespMsg = null;
          }
        }, e => {
          this.processingOCR = false;
          this.enableOCRModeCascader = false;
          this.enableNewOCROption = true;
          this.isOCRFailed = true;
          this.ocrGeneratedClaimNo = null;
          this.errorRespMsg = null;
        })
      }
      else {
        this.msg.warning("Please select correct mode." ,{nzDuration : 1000})
        this.isOCRFailed = true;
      }
    }
  }

  setDocumentImageURL(){
    if(this.documentClassification && this.commonUtility.isArrayIterable(this.documentClassification) && this.entityDocumentDO && this.commonUtility.isArrayIterable(this.entityDocumentDO)){
      this.documentClassification.forEach(doc=>{
        let entityDoc = this.entityDocumentDO.filter(d =>d.documentCd == doc.mapped_requirement && d.entityImageName == d.file_name)
        if(entityDoc && entityDoc.length)
          doc['imageURL'] =  entityDoc[0] ?  entityDoc[0]['imageURL'] ?  entityDoc[0]['imageURL'] : null:null;
      })
    }
  }
  classificationDecision = "ACCEPT"
  changeInDocumentClassification(data, i){
    if(this.documentClassificationOriginal && this.commonUtility.isArrayIterable(this.documentClassificationOriginal) && this.documentClassificationOriginal.length && this.documentClassificationOriginal[i] && this.documentClassificationOriginal[i].mapped_requirement == data.mapped_requirement){
      this.classificationDecision = "RECTIFY";
    }
    console.log("document changed = ",data);
  }
  
  saveClassiFication(){
    this.pseudoLoad(0);
     let request = {
        "product_type":"IDP",
        "module_name":"OCR",
        "business_process":"FWARISKANALYSIS",
        "workflowCd":this.currentWorkflowCd,  // will changed based on LOB
        "source" : "OCR",
        "companyCd":this.currentCompanyCd,
        "countryCd":this.currentCountryCd,
        "output_lang": "",
        "AUTH_TOKEN": this.apiRequestService.token,
        "idp_guid": this.idp_guid,
        "request_id": this.request_id,
        "documentClassification": this.documentClassification,
        "document_classification": this.documentClassification,
        "document_classification_hil_decisionCd":  this.classificationDecision,
        "document_classification_hil_remark" : this.classificationRectificationRemark,
        "interpreted_information": null,
        "interpreted_HIL_decisionCd": null,
        "interpreted_hil_remark" : null,
        "extractionResult": {},
        "idp_version": "v2",
        "base64": ""
      }
    if(this.currentMode && (this.currentMode['key'] == "IDPV2")){
      let url =  `https://${this.appConfig.serverHost}/dev-fwa-generic/idp/hil/get_interpretation`;
      // this.processingOCR = true;
      const headers = { 'Content-Type': 'application/json' ,'Authorization' : this.apiRequestService.token};
      this.http.post<any>(url, request, { headers }).subscribe(resp => {
        this.documentInterpretationResp = resp;
        this.idp_summary = resp['idp_summary'] ? resp['idp_summary'] : this.idp_summary;
        this.classificationRectificationRemark = resp['document_classification_hil_remark'] ? resp['document_classification_hil_remark'] : "";
        this.jsonTransformFunctionForViewSummary(this.documentInterpretationResp);
        this.steps[this.stepCurrent-1].status = "finish"
        this.stepCurrent = this.stepCurrent + 1;
        this.steps[this.stepCurrent-1].status = "process"; 
        this.viewAudit(); 
        this.processingOCR = false;  
      }, e => {
        this.isOCRFailed = true;
        this.processingOCR = false;
        this.errorRespMsg = null;
      });
    }
    else if(this.currentMode && (this.currentMode['key'] == "IDPV3")){
      this.intakeData.documentClassification = this.documentClassification;
      let jsonString = JSON.stringify(request);
      let resultString = `${jsonString}`;
      this.processingOCR = true;
      this.IO['intakeDO']['componentGuid'] = this.idp_guid;
      this.IO['intakeDO']['componentIdNum'] = this.request_id;
      this.IO['intakeDO']['componentCd'] = "OCR";
      this.IO['intakeDO']['additionalField1'] = this.currentWorkflowCd;
      this.IO['intakeDO']['additionalField2'] = this.currentCompanyCd;
      this.IO['intakeDO']['additionalField3'] = this.currentCountryCd;
      this.IO['intakeDO']['intakeDocumentBase64'] = "";
      this.IO['intakeDO']['classificationDecisionCd'] = this.classificationDecision;
      this.IO['intakeDO']['processOutput'] = jsonString;
      this.IO['intakeDO']['intakeReqNum'] = this.intakeNum;
      this.IO['intakeDO']['entityRefNum'] = null;
      this.IO['intakeDO']['idp_version'] = "v3";
      this.apiRequestService.postCallWithAPIMapper('classificationEditSave', this.IO).subscribe(resp =>{
        let data = this.commonUtility.deepCopy(JSON.parse(resp.intakeDO.processOutput));
        this.IO = resp;
        if(data){
          this.intakeData = this.commonUtility.deepCopy(data);
          if(this.intakeData && Object.keys(this.intakeData )){
            this.documentClassification = this.intakeData.documentClassification ? this.intakeData.documentClassification : [];
            this.idp_summary = this.intakeData['idp_summary'] ? this.intakeData['idp_summary'] : ""
            this.classificationRectificationRemark = this.intakeData['document_classification_hil_remark'] ? this.intakeData['document_classification_hil_remark'] : ""
            this.documentClassificationOriginal = this.commonUtility.deepCopy(this.documentClassification)
            this.idp_guid = this.intakeData.idp_guid ? this.intakeData.idp_guid : null;
            this.intakeNum = resp.intakeDO.intakeReqNum;
            this.workflowStageCd = resp.intakeDO['stageCd'] ? resp.intakeDO['stageCd']  : null;
            this.request_id = this.intakeData.request_id ? this.intakeData.request_id : null;
            this.isOCRFailed = false;
            this.processingOCR = false;
            this.viewAudit();
          }
          else{
            this.isOCRFailed = true;
            this.processingOCR = false; 
          }
        }
        else{
          this.isOCRFailed = true;
          this.processingOCR = false; 
        }
      }, e => {
        this.isOCRFailed = true;
        this.processingOCR = false;
        this.errorRespMsg = null;
      })
    }
    else if(this.currentMode && (this.currentMode['key'] == "IDPV4")){
      this.intakeData.documentClassification = this.documentClassification;
      let jsonString = JSON.stringify(request);
      let resultString = `${jsonString}`;
      this.processingOCR = true;
      this.IO['transactionMode'] = "ASYNC";
      this.IO['intakeDO']['componentGuid'] = this.idp_guid;
      this.IO['intakeDO']['componentIdNum'] = this.request_id;
      this.IO['intakeDO']['componentCd'] = "OCR";
      this.IO['intakeDO']['additionalField1'] = this.currentWorkflowCd;
      this.IO['intakeDO']['additionalField2'] = this.currentCompanyCd;
      this.IO['intakeDO']['additionalField3'] = this.currentCountryCd;
      this.IO['intakeDO']['intakeDocumentBase64'] = "";
      this.IO['intakeDO']['classificationDecisionCd'] = this.classificationDecision;
      this.IO['intakeDO']['processOutput'] = jsonString;
      this.IO['intakeDO']['intakeReqNum'] = this.intakeNum;
      this.IO['intakeDO']['entityRefNum'] = null;
      this.IO['intakeDO']['idp_version'] = "v4";
      this.apiRequestService.postCallWithAPIMapper('classificationEditSave', this.IO).subscribe(resp =>{
        let data = this.commonUtility.deepCopy(JSON.parse(resp.intakeDO.processOutput));
        this.IO = resp;
        if(data){
          this.intakeData = this.commonUtility.deepCopy(data);
          if(this.intakeData && Object.keys(this.intakeData)){
            this.documentClassification = this.intakeData.documentClassification ? this.intakeData.documentClassification : [];
            this.idp_summary = this.intakeData['idp_summary'] ? this.intakeData['idp_summary'] : ""
            this.classificationRectificationRemark = this.intakeData['document_classification_hil_remark'] ? this.intakeData['document_classification_hil_remark'] : ""
            this.documentClassificationOriginal = this.commonUtility.deepCopy(this.documentClassification)
            this.idp_guid = this.intakeData.idp_guid ? this.intakeData.idp_guid : null;
            this.intakeNum = resp.intakeDO.intakeReqNum;
            this.intakeGuid = resp.intakeDO.guid;
            this.workflowStageCd = resp.intakeDO['stageCd'] ? resp.intakeDO['stageCd']  : null;
            this.request_id = this.intakeData.request_id ? this.intakeData.request_id : null;
            this.isOCRFailed = false;
            this.processingOCR = false;
            // this.asyncMSGTitle = `Documents Classification is in process for intake number ${this.intakeNum}.`
            // this.showAsyncFlowStatus = true;
            this.viewAudit();
          }
          else{
            this.isOCRFailed = true;
            this.processingOCR = false; 
          }
        }
        else{
          this.isOCRFailed = true;
          this.processingOCR = false; 
        }
      }, e => {
        this.isOCRFailed = true;
        this.processingOCR = false;
        this.errorRespMsg = null;
      })
    }
    else {
      this.isOCRFailed = true;
      this.processingOCR = false;
      this.errorRespMsg = null;
    }
  }
  
  saveAndProceedClassiFication(){
    this.pseudoLoad(0)
    let request = {
       "product_type":"IDP",
       "module_name":"OCR",
       "business_process":"FWARISKANALYSIS",
       "workflowCd":this.currentWorkflowCd,  // will changed based on LOB
       "source" : "OCR",
       "companyCd":this.currentCompanyCd,
       "countryCd":this.currentCountryCd,
       "output_lang": "",
       "AUTH_TOKEN": this.apiRequestService.token,
       "idp_guid": this.idp_guid,
       "request_id": this.request_id,
       "documentClassification": this.documentClassification,
       "document_classification": this.documentClassification,
       "document_classification_hil_decisionCd":  this.classificationDecision,
       "document_classification_hil_remark" : this.classificationRectificationRemark,
       "interpreted_information": null,
       "interpreted_HIL_decisionCd": null,
       "interpreted_hil_remark" : null,
       "extractionResult": {},
        "idp_version": "v2",
       "base64": ""
     }
   if(this.currentMode && (this.currentMode['key'] == "IDPV2")){
     let url =  `https://${this.appConfig.serverHost}/dev-fwa-generic/idp/hil/get_interpretation`;
     this.processingOCR = true;
     const headers = { 'Content-Type': 'application/json' ,'Authorization' : this.apiRequestService.token};
     this.http.post<any>(url, request, { headers }).subscribe(resp => {
      // this.documentClassification = resp.documentClassification ? resp.documentClassification : [];
      this.documentInterpretationResp = this.commonUtility.deepCopy(resp);
      this.originalInterpretationResp = this.commonUtility.deepCopy(resp);
       this.idp_summary = resp['idp_summary'] ? resp['idp_summary'] : this.idp_summary;
       this.classificationRectificationRemark = resp['document_classification_hil_remark'] ? resp['document_classification_hil_remark'] : "";
       this.interpretationMetaData = resp['extractionResult'] ? resp['extractionResult']['interpreted_meta_data'] ? resp['extractionResult']['interpreted_meta_data'] : null : null;
       this.interpretation_metrics = resp['metrics'] ? resp['metrics'] : null;
      if(this.interpretation_metrics && Object.keys(this.interpretation_metrics))
          this.setConfigForInterpretationMetrics();
       this.jsonTransformFunctionForViewSummary(this.documentInterpretationResp);
       this.interpretation_metrics = resp['metrics']
       this.setConfigForInterpretationMetrics();
       this.steps[this.stepCurrent-1].status = "finish"
       this.stepCurrent = this.stepCurrent + 1;
       this.steps[this.stepCurrent-1].status = "process"; 
       this.viewAudit(); 
       this.processingOCR = false;  
     }, e => {
       this.isOCRFailed = true;
       this.processingOCR = false;
       this.errorRespMsg = null;
     });
   }
   else if(this.currentMode && (this.currentMode['key'] == "IDPV3")){
     this.intakeData.documentClassification = this.documentClassification;
     let jsonString = JSON.stringify(request);
     let resultString = `${jsonString}`;
     this.processingOCR = true;
     this.IO['intakeDO']['componentGuid'] = this.idp_guid;
     this.IO['intakeDO']['componentIdNum'] = this.request_id;
     this.IO['intakeDO']['componentCd'] = "OCR";
     this.IO['intakeDO']['additionalField1'] = this.currentWorkflowCd;
     this.IO['intakeDO']['additionalField2'] = this.currentCompanyCd;
     this.IO['intakeDO']['additionalField3'] = this.currentCountryCd;
     this.IO['intakeDO']['intakeDocumentBase64'] = "";
     this.IO['intakeDO']['classificationDecisionCd'] = this.classificationDecision;
     this.IO['intakeDO']['processOutput'] = jsonString;
     this.IO['intakeDO']['intakeReqNum'] = this.intakeNum;
     this.IO['intakeDO']['entityRefNum'] = null;
     this.IO['intakeDO']['idp_version'] = "v3";
     this.apiRequestService.postCallWithAPIMapper('proposalIntakeSubmit', this.IO).subscribe(resp =>{
       let data = this.commonUtility.deepCopy(JSON.parse(resp.intakeDO.processOutput));
       this.IO = resp;
       if(data){
         this.intakeData = this.commonUtility.deepCopy(data);
         if(this.intakeData && Object.keys(this.intakeData )){
           this.documentInterpretationResp = this.commonUtility.deepCopy(this.intakeData);
           this.originalInterpretationResp = this.commonUtility.deepCopy(this.intakeData);
           this.idp_summary =  this.intakeData['idp_summary'] ?  this.intakeData['idp_summary'] : this.idp_summary
           this.classificationRectificationRemark = this.intakeData['document_classification_hil_remark'] ? this.intakeData['document_classification_hil_remark'] : ""
           this.interpretationMetaData = this.intakeData['extractionResult'] ? this.intakeData['extractionResult']['interpreted_meta_data'] ? this.intakeData['extractionResult']['interpreted_meta_data'] : null :null
           this.jsonTransformFunctionForViewSummary(this.documentInterpretationResp);
           this.interpretation_metrics = this.intakeData['extractionResult']['metrics'] ? this.intakeData['extractionResult']['metrics'] : null;
           if(this.interpretation_metrics && Object.keys(this.interpretation_metrics))
            this.setConfigForInterpretationMetrics();
           this.intakeNum = resp.intakeDO.intakeReqNum;
           this.workflowStageCd = resp.intakeDO['stageCd'] ? resp.intakeDO['stageCd']  : null;
           this.steps[this.stepCurrent-1].status = "finish"
           this.stepCurrent = this.stepCurrent + 1;
           this.steps[this.stepCurrent-1].status = "process";  
           this.processingOCR = false;  
           this.viewAudit();
         }
         else{
           this.isOCRFailed = true;
           this.processingOCR = false; 
         }
       }
       else{
         this.isOCRFailed = true;
         this.processingOCR = false; 
       }
     }, e => {
       this.isOCRFailed = true;
       this.processingOCR = false;
       this.errorRespMsg = null;
     })
   } 
   else if(this.currentMode && (this.currentMode['key'] == "IDPV4")){
    this.intakeData.documentClassification = this.documentClassification;
    let jsonString = JSON.stringify(request);
    let resultString = `${jsonString}`;
    this.processingOCR = true;
    this.IO['transactionMode'] = "ASYNC";
    this.IO['intakeDO']['componentGuid'] = this.idp_guid;
    this.IO['intakeDO']['componentIdNum'] = this.request_id;
    this.IO['intakeDO']['componentCd'] = "OCR";
    this.IO['intakeDO']['additionalField1'] = this.currentWorkflowCd;
    this.IO['intakeDO']['additionalField2'] = this.currentCompanyCd;
    this.IO['intakeDO']['additionalField3'] = this.currentCountryCd;
    this.IO['intakeDO']['intakeDocumentBase64'] = "";
    this.IO['intakeDO']['classificationDecisionCd'] = this.classificationDecision;
    this.IO['intakeDO']['processOutput'] = jsonString;
    this.IO['intakeDO']['intakeReqNum'] = this.intakeNum;
    this.IO['intakeDO']['entityRefNum'] = null;
    this.IO['intakeDO']['idp_version'] = "v4";
    this.apiRequestService.postCallWithAPIMapper('proposalIntakeSubmit', this.IO).subscribe(resp =>{
      // let data = this.commonUtility.deepCopy(JSON.parse(resp.intakeDO.processOutput));
      this.IO = resp;
      if(resp){
        // this.intakeData = this.commonUtility.deepCopy(data);
        if(resp.intakeDO){
          // this.documentInterpretationResp = this.commonUtility.deepCopy(this.intakeData);
          // this.originalInterpretationResp = this.commonUtility.deepCopy(this.intakeData);
          // this.idp_summary =  this.intakeData['idp_summary'] ?  this.intakeData['idp_summary'] : this.idp_summary;
          // this.classificationRectificationRemark = this.intakeData['document_classification_hil_remark'] ? this.intakeData['document_classification_hil_remark'] : ""
          // this.interpretationMetaData = this.intakeData['extractionResult'] ? this.intakeData['extractionResult']['interpreted_meta_data'] ? this.intakeData['extractionResult']['interpreted_meta_data'] : null :null
          // this.jsonTransformFunctionForViewSummary(this.documentInterpretationResp);
          // this.interpretation_metrics = this.intakeData['metrics'] ? this.intakeData['metrics'] : null;
          // if(this.interpretation_metrics && Object.keys(this.interpretation_metrics))
          //  this.setConfigForInterpretationMetrics();
          this.intakeGuid = resp.intakeDO.guid;
          this.intakeNum = resp.intakeDO.intakeReqNum;
          this.workflowStageCd = resp.intakeDO['stageCd'] ? resp.intakeDO['stageCd']  : null;
          // this.steps[this.stepCurrent-1].status = "finish"
          // this.stepCurrent = this.stepCurrent + 1;
          // this.steps[this.stepCurrent-1].status = "process";  
          this.asyncMSGTitle = `Documents Interpretation is in process for intake number ${this.intakeNum}.`
          this.showAsyncFlowStatus = true;
          this.callCount = 0;
          this.showRefreshButton = false;
          this.processingOCR = false;  
          // this.viewAudit();
        }
        else{
          this.isOCRFailed = true;
          this.processingOCR = false; 
        }
      }
      else{
        this.isOCRFailed = true;
        this.processingOCR = false; 
      }
    }, e => {
      this.isOCRFailed = true;
      this.processingOCR = false;
      this.errorRespMsg = null;
    })
  }
   else {
     this.isOCRFailed = true;
     this.processingOCR = false;
     this.errorRespMsg = null;
   }
 }
 lookupsToBind
 lookup$
  jsonTransformFunctionForViewSummary(inputJson){
    if(inputJson && inputJson.interpreted_information && Object.keys(inputJson.interpreted_information).length && this.interpretationMetaData && Object.keys(this.interpretationMetaData)){
      this.interpretationSectionsJSON = this.jsonTransformService.transformInputToSummarySections(inputJson.interpreted_information,  this.notAllowedSections,this.interpretationMetaData);
      this.lookupsToBind = this.interpretationSectionsJSON['lookupCdList']
      this.lookup$ = this.commonUtility.initializeLookupList(this.lookupsToBind)
      this.stopFunction();
      this.showAsyncFlowStatus = false;
    }
    else {
      this.isOCRFailed = true;
      this.errorTitleMsg = "Unable to process interpretation"
      this.ocrFailedErrorMsg = "Something went wrong on interpretation step. Our team is already on it, and we'll have things back up and running smoothly as soon as possible. Thank you for your patience."
    }
    console.info("transformed JSON = ",this.interpretationSectionsJSON);
  }

  interpretationDecisionChange(option){
    if(option == 'REJECT'){
       this.enableRejectReason = true;
       this.interpretationSaveDisabled = true;
      //  this.cancelCurrentProcess();
    }
    if(option == 'ACCEPT') {
      this.enableRejectReason = false;
      this.interpretationSaveDisabled = false;
    }
    if(option == 'RECTIFY') {
      this.enableRejectReason = false;
      this.interpretationSaveDisabled = false;
    }
  }

  checkRejectReason(){
    if(this.rejectReasonCategory && this.rejectReason != null && this.rejectReason != "") this.interpretationSaveDisabled = false;
  }
  checkCancelReason(){
    if(this.cancelReasonCategory && this.cancelReason != null && this.cancelReason != "") this.enableCancelIDPSaveButton = false;
  }

  jsonUpdated(event){
    this.documentInterpretationResp['interpreted_information'] = event;
    this.jsonTransformFunctionForViewSummary(this.documentInterpretationResp);
    this.msg.success("Values updated successfully!", {nzDuration : 1000})
  }

  saveInterpretation(){
    let diff = this.jsonTransformService.compareJson(this.originalInterpretationResp['interpreted_information'],this.documentInterpretationResp['interpreted_information'])
    console.log("json compare resp =",diff);
    if(this.interpretationDecision == 'REJECT') this.interpretationDecision == 'REJECT'
    else if(diff && diff.changed) this.interpretationDecision = 'RECTIFY'
    else this.interpretationDecision = 'ACCEPT'

    this.pseudoLoad(0);
    let request = {
      "product_type":"IDP",
      "module_name":"OCR",
      "business_process":"FWARISKANALYSIS",
      "workflowCd":this.currentWorkflowCd,  // will changed based on LOB
      "source" : "OCR",
      "companyCd":this.currentCompanyCd,
      "countryCd":this.currentCountryCd,
      "output_lang": "",
      "AUTH_TOKEN": this.apiRequestService.token,
      "idp_guid": this.idp_guid,
      "request_id": this.request_id,
      "documentClassification": this.documentClassification,
      "document_classification": this.documentClassification,
      "document_classification_hil_decisionCd": this.classificationDecision,
      "document_classification_hil_remark" : this.documentInterpretationResp['document_classification_hil_remark'] ? this.documentInterpretationResp['document_classification_hil_remark'] : null,
      "reason":this.rejectReason,
      "reasonCategoryCd":this.rejectReasonCategory,
      "interpreted_information": this.documentInterpretationResp['interpreted_information'] ? this.documentInterpretationResp['interpreted_information'] : null,
      "interpreted_hil_decisionCd": this.interpretationDecision,
      "interpreted_hil_remark" : this.interpretationRectificationRemark,
      "idp_version": "v2"
    }
    if(this.currentMode && (this.currentMode['key'] == "IDPV2")){
    let url =  `https://${this.appConfig.serverHost}/dev-fwa-generic/idp/hil/finalize_idp`;
        this.processingOCR = true;
        const headers = { 'Content-Type': 'application/json' ,'Authorization' : this.apiRequestService.token};
        this.http.post<any>(url, request, { headers }).subscribe(resp => {
          this.documentInterpretationFinalize = resp;
          // this.documentClassification = resp.documentClassification ? resp.documentClassification : [];
          this.documentInterpretationResp = this.commonUtility.deepCopy(resp);
          this.originalInterpretationResp = this.commonUtility.deepCopy(resp);
          this.jsonTransformFunctionForViewSummary(this.documentInterpretationResp);
          this.idp_summary = resp['idp_summary'] ? resp['idp_summary'] : this.idp_summary;
          this.classificationRectificationRemark = resp['document_classification_hil_remark'] ? resp['document_classification_hil_remark'] : "";
          this.interpretationRectificationRemark = resp['interpreted_hil_remark'] ? resp['interpreted_hil_remark'] : "";
          // this.intimationNum = this.IO.intakeDO['intakeIntimationRefNum'] ? this.IO.intakeDO['intakeIntimationRefNum'] : null
          this.intimationNumber = resp['downstream_responses'] ? resp['downstream_responses'][0] ? resp['downstream_responses'][0].intimationNum ? resp['downstream_responses'][0].intimationNum : null : null : null;
          this.intimationGuid = resp['downstream_responses'] ? resp['downstream_responses'][0] ? resp['downstream_responses'][0].intimationGuid ? resp['downstream_responses'][0].intimationGuid : null : null : null;
          this.finalStatus = resp['overall_status'];
          // this.successResultSubTitle = `Proposal created with number : ${this.intimationNumber}`;
          this.successResultSubTitle = `Proposal created${this.proposalNum ? ' with number : ' + this.proposalNum : ''}`;          this.steps[this.stepCurrent-1].status = "finish"
          this.stepCurrent = this.stepCurrent + 1;
          this.steps[this.stepCurrent-1].status = "process";  
          this.failSubTitle = `There is an issue with request ID ${this.request_id}. Please check with administrator.`
          this.viewAudit();
          this.processingOCR = false; 
        }, e => {
          this.isOCRFailed = true;
          this.processingOCR = false;
          this.errorRespMsg = null;
        });
      }
    else if(this.currentMode && (this.currentMode['key'] == "IDPV3")){
       let jsonString = JSON.stringify(request);
        this.processingOCR = true;
        this.IO['intakeDO']['componentGuid'] = this.idp_guid;
        this.IO['intakeDO']['componentIdNum'] = this.request_id;
        this.IO['intakeDO']['componentCd'] = "OCR";
        this.IO['intakeDO']['additionalField1'] = this.currentWorkflowCd;
        this.IO['intakeDO']['additionalField2'] = this.currentCompanyCd;
        this.IO['intakeDO']['additionalField3'] = this.currentCountryCd;
        this.IO['intakeDO']['intakeDocumentBase64'] = "";
        this.IO['intakeDO']['classificationDecisionCd'] = this.classificationDecision;
        this.IO['intakeDO']['processOutput'] = jsonString;
        this.IO['intakeDO']['intakeReqNum'] = this.intakeNum;
        this.IO['intakeDO']['entityRefNum'] = null;
        this.IO['intakeDO']['rejectionReason'] = this.rejectReason;
        this.IO['intakeDO']['rejectionReasonCategoryCd'] = this.rejectReasonCategory;
        this.IO['intakeDO']['interpretedDecisionCd'] = this.interpretationDecision;
        this.IO['intakeDO']['interpretationRemark'] = this.interpretationRectificationRemark;
        this.IO['intakeDO']["classificationRemark"] = this.documentInterpretationResp['document_classification_hil_remark'] ? this.documentInterpretationResp['document_classification_hil_remark'] : null,
        this.IO['intakeDO']['idp_version'] = "v3";
        this.apiRequestService.postCallWithAPIMapper('proposalIntakeInterpretationSubmit', this.IO).subscribe(resp =>{
          let data = this.commonUtility.deepCopy(JSON.parse(resp.intakeDO.processOutput));
          this.IO = resp;
          if(data){
            this.intakeData = this.commonUtility.deepCopy(data);
            if(this.intakeData && Object.keys(this.intakeData)){
              this.documentInterpretationFinalize =  this.intakeData;
              this.idp_summary =  this.intakeData['idp_summary'] ?  this.intakeData['idp_summary'] : this.idp_summary;
              this.classificationRectificationRemark = this.intakeData['document_classification_hil_remark'] ? this.intakeData['document_classification_hil_remark'] : "";
              this.interpretationRectificationRemark = resp.intakeDO['interpretationRemark'] ? resp.intakeDO['interpretationRemark'] : "";
              this.finalStatus =  this.intakeData['overall_status'];
              // this.intimationNumber = resp.intakeDO['intakeIntimationRefNum'] ? resp.intakeDO['intakeIntimationRefNum'] : null
              this.proposalNum = resp.intakeDO['intakeIntimationRefNum'] ? resp.intakeDO['intakeIntimationRefNum'] : null
              this.intimationGuid = resp.intakeDO['entityRefNum'] ? resp.intakeDO['entityRefNum'] : null
              this.workflowStageCd = resp.intakeDO['stageCd'] ? resp.intakeDO['stageCd']  : null;
              if(this.workflowStageCd == "REJECT"){
                this.enableRejectInfo = true;
                this.showRejectMsg =  `Intake number ${this.IO.intakeDO.intakeReqNum} is rejected.`;
                this.rejectReason = this.IO.intakeDO.rejectionReason;
                this.rejectReasonCategory = this.IO.intakeDO.rejectionReasonCategoryCd;
              }
              this.steps[this.stepCurrent-1].status = "finish"
              this.stepCurrent = this.stepCurrent + 1;
              this.steps[this.stepCurrent-1].status = "process";  
              this.processingOCR = false; 
              // this.successResultSubTitle = `Proposal created with number : ${this.proposalNum}`;
              this.successResultSubTitle = `Proposal created${this.proposalNum ? ' with number : ' + this.proposalNum : ''}`;              this.failSubTitle =  this.proposalNum ? "" : `Intake Number is ${this.intakeNum}`;
              this.viewAudit();
            }
            else{
                this.isOCRFailed = true;
                this.processingOCR = false; 
            }
          }
          else{
            this.isOCRFailed = true;
            this.processingOCR = false; 
          }
        }, e => {
          this.isOCRFailed = true;
          this.processingOCR = false;
          this.errorRespMsg = null;
        });
    }
    else if(this.currentMode && (this.currentMode['key'] == "IDPV4")){
      let jsonString = JSON.stringify(request);
       this.processingOCR = true;
       this.IO['transactionMode'] = "ASYNC";
       this.IO['intakeDO']['componentGuid'] = this.idp_guid;
       this.IO['intakeDO']['componentIdNum'] = this.request_id;
       this.IO['intakeDO']['componentCd'] = "OCR";
       this.IO['intakeDO']['additionalField1'] = this.currentWorkflowCd;
       this.IO['intakeDO']['additionalField2'] = this.currentCompanyCd;
       this.IO['intakeDO']['additionalField3'] = this.currentCountryCd;
       this.IO['intakeDO']['intakeDocumentBase64'] = "";
       this.IO['intakeDO']['classificationDecisionCd'] = this.classificationDecision;
       this.IO['intakeDO']['processOutput'] = jsonString;
       this.IO['intakeDO']['intakeReqNum'] = this.intakeNum;
       this.IO['intakeDO']['entityRefNum'] = null;
       this.IO['intakeDO']['rejectionReason'] = this.rejectReason;
       this.IO['intakeDO']['rejectionReasonCategoryCd'] = this.rejectReasonCategory;
       this.IO['intakeDO']['interpretedDecisionCd'] = this.interpretationDecision;
       this.IO['intakeDO']['interpretationRemark'] = this.interpretationRectificationRemark;
       this.IO['intakeDO']["classificationRemark"] = this.documentInterpretationResp['document_classification_hil_remark'] ? this.documentInterpretationResp['document_classification_hil_remark'] : null,
       this.IO['intakeDO']['idp_version'] = "v4";
       this.apiRequestService.postCallWithAPIMapper('proposalIntakeInterpretationSubmit', this.IO).subscribe(resp =>{
        //  let data = this.commonUtility.deepCopy(JSON.parse(resp.intakeDO.processOutput));
         this.IO = resp;
         if(resp){
          //  this.intakeData = this.commonUtility.deepCopy(data);
           if(resp.intakeDO){
            //  this.documentInterpretationFinalize =  this.intakeData;
            //  this.idp_summary =  this.intakeData['idp_summary'] ?  this.intakeData['idp_summary'] : this.idp_summary;
            //  this.classificationRectificationRemark = this.intakeData['document_classification_hil_remark'] ? this.intakeData['document_classification_hil_remark'] : "";
            //   this.interpretationRectificationRemark = resp.intakeDO['interpretationRemark'] ? resp.intakeDO['interpretationRemark'] : "";
            //  this.finalStatus =  this.intakeData['overall_status'];
            //  this.intimationNumber = resp.intakeDO['intakeIntimationRefNum'] ? resp.intakeDO['intakeIntimationRefNum'] : null
             this.intakeGuid = resp.intakeDO.guid;
             this.intimationGuid = resp.intakeDO['entityRefNum'] ? resp.intakeDO['entityRefNum'] : null
             this.workflowStageCd = resp.intakeDO['stageCd'] ? resp.intakeDO['stageCd']  : null;
            //  this.steps[this.stepCurrent-1].status = "finish"
            //  this.stepCurrent = this.stepCurrent + 1;
            //  this.steps[this.stepCurrent-1].status = "process";  
             this.processingOCR = false; 
             this.asyncMSGTitle = `Documents Interpretation is in process for intake number ${this.intakeNum}.`
             this.showAsyncFlowStatus = true;
             this.callCount = 0;
             this.showRefreshButton = false;
            //  this.successResultSubTitle = `Intimation created with number : ${this.intimationNumber}`;
            //  this.failSubTitle =  this.intimationNumber ? "" : `Intake Number is ${this.intakeNum}`;
            //  this.viewAudit();
           }
           else{
               this.isOCRFailed = true;
               this.processingOCR = false; 
           }
         }
         else{
           this.isOCRFailed = true;
           this.processingOCR = false; 
         }
       }, e => {
         this.isOCRFailed = true;
         this.processingOCR = false;
         this.errorRespMsg = null;
       });
   }
    else {
      this.isOCRFailed = true;
      this.processingOCR = false;
      this.errorRespMsg = null;
    }
  }

  rejectInterpretation(){
    this.enableRejectReason = true;
    // this.steps[this.stepCurrent-1].status = "finish"
    // this.stepCurrent = this.stepCurrent + 1;
    // this.steps[this.stepCurrent-1].status = "process";
  }

  backToSearchScreen() {
    setTimeout(() => { this.router.navigate(['/app/nbu/proposal/search']) }, 10);
  }

  openTransactionDetails(inboxType?) {
    setTimeout(() => { this.router.navigate(['/app/nbu/proposal/search'])}, 10);
    // this.msg.loading("Opening Proposal", {nzDuration: 3000})
    // let transactionDataIO: any = [];
    // if (this.intimationGuid && this.navigation && this.navigation.extras && this.navigation.extras.state && this.navigation.extras.state.intimationType) {
    //   let serviceTask = this.configData['IntimationTypeServiceTaskToIntimationSourceCdMapper'][this.navigation.extras.state.intimationType]
    //   this.intimationService.getIntimationByGuid(this.intimationGuid).
    //     subscribe(resp => {
    //       if (resp && Object.keys(resp).length) {
    //         transactionDataIO = resp;
    //         this.interactService.sendIOToTransaction(serviceTask, transactionDataIO, null, null, inboxType, true)
    //         this.router.navigate(['/app/nbu/transaction/details'], { queryParams: {}, replaceUrl: false });
    //       }
    //     });
    // }
  }

  fetchRouteStateData() {
    this.navigation = this.router.getCurrentNavigation();
    if (this.navigation && this.navigation.extras && this.navigation.extras.state && this.navigation.extras.state.redirectToURL) {
      this.redirectBackTo = this.navigation.extras.state.redirectToURL;
    }
  }

  fetchTransaction(intimationNum) {
    let transactionDataIO: any = [];

    if (this.navigation && this.navigation.extras && this.navigation.extras.state && this.navigation.extras.state.intimationType) {
      let serviceTask = this.configData['IntimationTypeServiceTaskToIntimationSourceCdMapper'][this.navigation.extras.state.intimationType]
      this.intimationService.fetchByIntimationNumber(intimationNum).
        subscribe(resp => {
          if (resp && Object.keys(resp).length) {
            transactionDataIO = resp;
            this.interactService.sendIOToTransaction(serviceTask, transactionDataIO, null, null, 'search', null);
            // if (this.viewType == "ENQUIRY")
            //   this.router.navigate(['/app/claims/transaction/enquiry'], { queryParams: {}, replaceUrl: false });
            // else
            this.router.navigate(['/app/claims/transaction/details'], { queryParams: {}, replaceUrl: false });
          }
        });
    }
  }

  submitPassword(){
    if(this.capturedPassword == "IDP@Future"){
      this.capturedPassword = ""
      this.currentMode = this.OCRModes[1];
      this.isOCRFailed= false;
      this.ocrGeneratedClaimNo = null;
      this.showOCRExtractionResult = null;
      this.showIDPV2RespCard = null;
    }
    else  this.msg.error(`ICP V2 password is incorrect, please enter correct password.`,{nzDuration : 2000});
    this.capturedPassword = ""
  }
  showAuditDrawer : boolean = false;
  moreAction(option){
    if(option.key == "AUDIT"){
      // this.viewAudit(option.api);
      this.showAuditDrawer = true;
    }
    else if(option.key == "SUMMARY"){
      this.showIDPSummaryModal = true;
    }
    else{
      this.modalCancelIDP=true
      // this.cancelCurrentProcess();
    }
  }

showAuditLoader : boolean = false;
auditTrail = []
IDPauditTrail = []
IntakeauditTrail = []
OverallAuditTrail = []
Array = Array
  viewAudit(){
    this.showAuditLoader = true;
    if(this.currentMode && (this.currentMode['key'] == "IDPV2")){
      let url = `https://${this.appConfig.serverHost}/dev-fwa-generic/idp/${this.idp_guid}/audit`
      const headers = { 'Content-Type': 'application/json' ,'Authorization' : this.apiRequestService.token};
      this.http.get<any>(url, { headers }).subscribe(resp => {
        if(resp && resp.audittrail){
          this.IDPauditTrail = resp.audittrail;
          this.auditColorSet();
        }
        this.showAuditLoader = false;
      }, e => {
      this.showAuditLoader = false;
      });
    }
    if(this.currentMode && (this.currentMode['key'] == "IDPV3")){
      let entityGuid = this.IO['intakeDO'] ? this.IO['intakeDO']['guid'] : null
      let url = `intakeFetchAudit/${entityGuid}`
      this.apiRequestService.getCallWithAPIMapper(url).subscribe(resp =>{
        if(resp && resp['idpAudit']){
          let audit = this.commonUtility.deepCopy(JSON.parse(resp['idpAudit']));
          if(audit && audit.audittrail){
            this.IDPauditTrail = audit.audittrail;
            this.auditColorSet();
          }
        }
        if(resp && resp['intakeAudit']) {
          // Intake Audit
        }
        this.showAuditLoader = false;
      }, e => {
        this.showAuditLoader = false;
      });
    }
  }
  auditColorSet(){
    this.IDPauditTrail.forEach(item => {
      if (item && item.statusForTheStage) {
        switch (item.statusForTheStage.toLowerCase()) {
          case "success": {
            item['color'] = "green";
            break;
          }
          case "inprogress": {
            item['color'] = "orange";
            break;
          }
          case "failed": {
            item['color'] = "red";
            break;
          }
          default: {
            item['color'] = "orange";
            console.log("Invalid choice");
            break;
          }
        }
      }
      else {
        item['color'] = "blue";
      }
    });
  }

  viewSummary(){};
  interpretationFieldChanged(event){
    console.log("field changed =", event);
    // this.interpretationDecision = 'RECTIFY';
    this.documentInterpretationResp = this.jsonTransformService.findAndReplaceKeyValue(this.documentInterpretationResp,event.key,event.value)
  }
  
  cancelReasonCategory = null
  cancelReason = ""
  modalCancelIDP : boolean = false
  enableCancelIDPSaveButton : boolean = true;
  cancelCurrentProcess(){ 
    let jsonString = JSON.stringify( this.intakeData);
    this.pseudoLoad(0);
    this.modalCancelIDP=false;
    this.processingOCR = true;
    let request = {
      "product_type":"IDP",
      "AUTH_TOKEN": this.apiRequestService.token,
      "module_name":"OCR",
      "business_process":"FWARISKANALYSIS",
      "workflowCd":this.currentWorkflowCd,  // will changed based on LOB
      "source" : "OCR",
      "companyCd":this.currentCompanyCd,
      "countryCd":this.currentCountryCd,
      "output_lang": "",
      "idp_guid": this.idp_guid,
      "request_id": this.request_id,
      "cancellationReasonCategoryCd": this.cancelReasonCategory,
      "cancelReason": this.cancelReason
    }

    if(this.currentMode && (this.currentMode['key'] == "IDPV2")){
      let url =  `https://${this.appConfig.serverHost}/dev-fwa-generic/idp/cancel`;
      this.processingOCR = true;
      const headers = { 'Content-Type': 'application/json' ,'Authorization' : this.apiRequestService.token};
      this.http.post<any>(url, request, { headers }).subscribe(resp => {
        this.steps[0].status = "finish"
        this.steps[1].status = "finish"
        this.steps[2].status = "error"
        this.steps[3].status = "process"
        this.showCancelIDPStep = true;
        this.stepCurrent = 4;
        this.failSubTitle = ""
        // this.stepCurrent = 4;
        // this.steps[this.stepCurrent-1].status = "process";  
        this.processingOCR = false; 
        this.modalCancelIDP=false;
      }, e => {
        this.processingOCR = false; 
        this.isOCRFailed = true;
        this.modalCancelIDP=false;
      });
    }
    if(this.currentMode && (this.currentMode['key'] == "IDPV3")){
        this.IO['intakeDO']['componentGuid'] = this.idp_guid;
        this.IO['intakeDO']['componentIdNum'] = this.request_id;
        this.IO['intakeDO']['componentCd'] = "OCR";
        this.IO['intakeDO']['additionalField1'] = this.currentWorkflowCd;
        this.IO['intakeDO']['additionalField2'] = this.currentCompanyCd;
        this.IO['intakeDO']['additionalField3'] = this.currentCountryCd;
        this.IO['intakeDO']['intakeDocumentBase64'] = "";
        this.IO['intakeDO']['classificationDecisionCd'] = this.classificationDecision;
        this.IO['intakeDO']['interpretedDecisionCd'] = this.interpretationDecision;
        this.IO['intakeDO']['interpreted_information'] = this.documentInterpretationResp && this.documentInterpretationResp['interpreted_information'] ? this.documentInterpretationResp['interpreted_information'] : null,
        this.IO['intakeDO']['processOutput'] = jsonString;
        this.IO['intakeDO']['intakeReqNum'] = this.intakeNum;
        this.IO['intakeDO']['cancellationReasonCategoryCd'] = this.cancelReasonCategory,
        this.IO['intakeDO']['cancelReason'] =  this.cancelReason,
        this.IO['intakeDO']['entityRefNum'] = null;
        this.IO['intakeDO']['idp_version'] = "v3";
      this.apiRequestService.postCallWithAPIMapper('/intake/hil/cancelIdp', this.IO).subscribe(resp =>{
        this.steps[0].status = "finish"
        this.steps[1].status = "finish"
        this.steps[2].status = "error"
        this.steps[3].status = "process"
        this.showCancelIDPStep = true;
        this.stepCurrent = 4;
        this.failSubTitle = `Intake Number ${this.intakeNum} canceled.`
        // this.stepCurrent = 4;
        // this.steps[this.stepCurrent-1].status = "process";  
        this.processingOCR = false; 
        this.modalCancelIDP=false;
      }, e => {
        this.processingOCR = false; 
        this.isOCRFailed = true;
        this.modalCancelIDP=false;
      });
    }
   }
  
  headers: HttpHeaders = new HttpHeaders({
    'Authorization': this.apiRequestService.token,
    'applicationId': environment.applicationId,
    'hash': '7h1nk[)j',
  });
  
  viewDocument(documentDO,action,splitMode?){
    let url = documentDO ? documentDO.imageURL ? documentDO.imageURL : '/mnt/azure/requirement/M3_CLIENT_Y3LAn1RExT.pdf' : '';
    let base64StrSubject: Subject<any> = new Subject();
    this.documentName = documentDO.file_name
    let downloadFileName = documentDO.file_name;
    let fileExtension = this.guessFileExtension(url)
    downloadFileName = downloadFileName+"."+fileExtension
    // Basic checks and resets
    this.previewDataStream = null;
    this.previewDocumentDO = documentDO || {};
    // this.previewRequirementDO = requirementDO || {};
    this.previewFileUrl = url;
    if (!url) return false;

    let body = { "imageURL": url };
    let guessedFilename = this.guessFileName(url);

    /* No need to fetch file if file is not previewable */
    if ('preview' == action && !this.fileIsPreviewable(url)) {
      this.previewDataStream = null;
      this.modalFilePreview = true; //open the modal anyway, and show "download"
      return false;
    }

    this.modalFilePreview = ('preview' == action);

    this.fileIsBeingDownloaded = true;

    /* Get file contents (bin) */
    this.http.post<Blob>(this.fileFetchEndpoint, body, {
      headers: this.headers,
      responseType: 'blob' as 'json'
    })
      .pipe(map(res => {
        switch (action) {
          case 'download':
            this.fileIsBeingDownloaded = false;
            this.downloadFile(res, downloadFileName);
            break;
          case 'return':
            this.fileIsBeingDownloaded = false;
            return res;
          case 'preview':
            let me = this;
            /* Special Case Handling: TIFF, TIF using JS decoder */
            
            let base64data;
            let reader = new FileReader();
            reader.readAsDataURL(res);
            reader.onloadend = function () {
              base64data = reader.result;
              base64data = base64data.split(',')[1];
              /* Decide Charset/Encoding */
              let charsetEncoding = 'data:image/jpeg;base64';
              switch (me.guessFileType(url)) {
                case 'Image':
                  charsetEncoding = 'data:image/jpeg;base64';
                  break;
                case 'Video':
                  charsetEncoding = 'data:video/mp4;base64';
                  break;
                case 'Audio':
                  charsetEncoding = 'data:audio/ogg;base64';
                  break;
                case 'Document':
                  charsetEncoding = 'data:application/' + me.guessFileExtension(url) + ';base64';
                  break;
                case 'Html':
                  charsetEncoding = 'data:text/html;base64';
                  break;
                case 'Tiff' : 
                  charsetEncoding = "";
                  base64data = new Tiff({ buffer: reader.result }); 
                  break;

              }
              if ('pdf' == me.guessFileExtension(url)) {

                me.previewDataStream = me.base64ToArrayBuffer(base64data); //charsetEncoding + "," + base64data;
                // let splitModeObj = { imgBase64 : me.previewDataStream, closeDrawer: true,documentType:me.guessFileType(url),fileExtension:me.guessFileExtension(url),documentName:documentName}
                // me.interactService.viewDocumentInSplitMode(splitModeObj);
              } else if ('html' == me.guessFileExtension(url)) {
                let url = decodeURIComponent(escape(window.atob(base64data)));
                me.previewDataStream = me.sanitizer.bypassSecurityTrustHtml(url);
              }
              else{
                if(me.guessFileType(url) == 'Tiff') me.previewDataStream = base64data;
                else me.previewDataStream = me.sanitizer.bypassSecurityTrustUrl(charsetEncoding + "," + base64data);
              }
                me.previewDataStreamUnsanitized = charsetEncoding + "," + base64data;
              me.documentPreview = {fileName: downloadFileName + ' preview', dataStream: me.previewDataStream, fileType: me.guessFileType(url)}
              //me.previewDataStream = me.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(res));
              if (!splitMode) base64StrSubject.next(me.previewDataStreamUnsanitized);
              else {
                me.dataTransformService.isSidebarCollapsed = false;
                // let splitModeObj = { imgBase64: me.previewDataStreamUnsanitized, closeDrawer: true, documentType: me.guessFileType(url), fileExtension: me.guessFileExtension(url), documentName: documentName,allDocument:allDocument }
                // me.interactService.viewDocumentInSplitMode(splitModeObj);
              }
              me.openDraggableImgPreviewModal(downloadFileName);
              me.fileIsBeingDownloaded = false;
              me.modalFilePreview = false;
            };
            break;

            case "detect": 
              let fileBase64;
              let reader1 = new FileReader();
              reader1.readAsDataURL(res);
              reader1.onloadend = function () {
                fileBase64 = reader1.result;
                fileBase64 = fileBase64.split(',')[1];
                me.detectDocument(fileBase64);
              };
              break;
          }
      }))
      .subscribe(d => { }, e => { console.log("Document Fetch http err", e) });
    if (!splitMode) return base64StrSubject;
  }

  viewDocumentBase64(document,action){
    this.documentName = document.file_name
    let base64data = document['base64'].split(',')[1];
    /* Decide Charset/Encoding */
    let charsetEncoding = 'data:image/jpeg;base64';
    switch (this.guessFileType(this.documentName)) {
      case 'Image':
        charsetEncoding = 'data:image/jpeg;base64';
        break;
      case 'Video':
        charsetEncoding = 'data:video/mp4;base64';
        break;
      case 'Audio':
        charsetEncoding = 'data:audio/ogg;base64';
        break;
      case 'Document':
        charsetEncoding = 'data:application/' + this.guessFileExtension(this.documentName) + ';base64';
        break;
      case 'Html':
        charsetEncoding = 'data:text/html;base64';
        break;
      case 'Tiff' : 
      charsetEncoding = "";
      base64data = new Tiff({ buffer: this.base64ToArrayBuffer(base64data)}); 
      break;
    }
    if ('pdf' == this.guessFileExtension(this.documentName)) {

      this.previewDataStream = this.base64ToArrayBuffer(base64data); //charsetEncoding + "," + base64data;
      // let splitModeObj = { imgBase64 : me.previewDataStream, closeDrawer: true,documentType:me.guessFileType(url),fileExtension:me.guessFileExtension(url),documentName:documentName}
      // me.interactService.viewDocumentInSplitMode(splitModeObj);
    } else if ('html' == this.guessFileExtension(this.documentName)) {
      let url = decodeURIComponent(escape(window.atob(base64data)));
      this.previewDataStream = this.sanitizer.bypassSecurityTrustHtml(url);
    }
    else{
       if(this.guessFileType(this.documentName) == 'Tiff') this.previewDataStream = base64data;
       else this.previewDataStream = this.sanitizer.bypassSecurityTrustUrl(charsetEncoding + "," + base64data);
    }        
      // this.previewDataStream = this.sanitizer.bypassSecurityTrustUrl(charsetEncoding + "," + base64data);
    this.previewDataStreamUnsanitized = charsetEncoding + "," + base64data;
    this.documentPreview = {fileName: this.documentName + ' preview', dataStream: this.previewDataStream, fileType: this.guessFileType(this.documentName)}
    // this.previewDataStream = document['base64']
    // this.documentPreview = {fileName: this.documentName + ' preview', dataStream: this.previewDataStream}
    this.openDraggableImgPreviewModal(this.documentName);
    this.fileIsBeingDownloaded = false;
    this.modalFilePreview = false;
  }

  openDraggableImgPreviewModal(fileName) {
    this.draggableBoxesforDocument = [];
    // let previewName = this.guessOriginalFileNameFromImgURL(this.previewFileUrl) + ' preview'
    let obj = {
      title: fileName, width: "", height: "650px", minWidth: "", type: "documentPreview", open: true, minimized: false, zIndex: 999, data: { id: 10, desc: "Pass a data object" }, toReset: 'documentPreview'
    }
    this.draggableBoxesforDocument.push(obj);
    this.enableDraggableBox = true;
  }
  guessFileName(url) {
    if (!url) return '';
    let character = (url.indexOf('\\') > -1) ? '\\' : '/';
    return url.substring(url.lastIndexOf(character) + 1);
  }
  guessFileExtension(url) {
    let filename = this.guessFileName(url);
    return String(filename.substring(filename.lastIndexOf(".") + 1)).toLowerCase();
  }

  /* Guess filetype IF extension is not found in file URL (Eg: filenet case) */
  guessFileExtensionFromMIME(url) {
    // (1) Take from entityImageMimeType (2) Split `/` (3) Return extension
  }

  /* Generic function to guess file type */
  /* NOW ALSO USED as for finding 'supported files' *** */
  guessFileType(url): string {
    let extension = url;
    if (url && url.length > 4) extension = this.guessFileExtension(url);
    /* Find file type */
    if (['jpg', 'png', 'x-png', 'jpeg', 'pjpeg', 'jfif', 'gif', 'bmp', 'webp'].includes(extension)) return "Image";
    else if (['pdf'].includes(extension)) return "PDF";
    else if (['tiff', 'tif'].includes(extension)) return "Tiff";
    else if (['doc', 'docx'].includes(extension)) return "Document";
    else if (['mp4', 'mov', 'avi', 'mpeg', 'webm'].includes(extension)) return "Video";
    else if (['mp3', 'wav', 'ogg'].includes(extension)) return "Audio";
    else if (['xls', 'xlsx', 'xlt', 'xltx', 'xlsm', 'xlsb', 'xla', 'xlam', 'xltm'].includes(extension)) return "Sheet";
    else if (['zip', 'gz', 'rar', 'rar5'].includes(extension)) return "Archive";
    else if (['eml', 'msg'].includes(extension)) return "Email";
    return "File"; // un-supported
  }
  fileIsPreviewable(url): boolean {
    let supportedFormats = [ // Add all supported formats here
      'jpg', 'png', 'jpeg', 'jfif', 'gif', 'bmp', 'webp', 'pjpeg', //Images
      'tif', 'tiff', // TIFF images (requires decoder plugin)
      'mp4', 'mov', 'avi', 'mpeg', 'webm', // Videos
      'mp3', 'wav', 'ogg', //Audio
      'pdf', // PDF Doc
    ];
    let extension = this.guessFileExtension(url);
    return supportedFormats.includes(extension);
  }

  /* Emulate a download-file click */
  downloadFile(blob: any, filename: string): boolean {
    if (!filename) filename = 'file.jpg';
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.href = url;
    a.download = filename;
    a.click();
    return true;//url;
  }
    // Detect Document code start
  // isDocumentDetectionInProgress = false;
  detectDocument(base64) {
    const headers = { 'Content-Type': 'application/json' };
    let request = {
      "product_type": "FWARISKANALYSIS",
      "business_process": "AIOCR",
      "module_name": "OCR",
      "file":base64
  }
   let URL = `https://${this.appConfig.serverHost}/dev-fwa-generic/ocr/document_classification`
  // this.documentDetectionSuccess = true;
    this.http.post<any>(URL, request, { headers })
      .subscribe(jsonResp => {
        if (jsonResp) {
          // this.isDocumentDetectionInProgress = false;
          this.documentDetectionSuccess = true;
          this.documentDetectionResponse = jsonResp;
          this.msg.remove(this.documentDetectionMsg);
          // this.msg.success("Document detection is successful", {nzDuration: 2000});
          console.log("file detect response", jsonResp)
        }
      });

  }
    /* ================== DATA FORMATS INTERCHANGE ================== */
    base64ToArrayBuffer(base64) {

      const base64regex = /^[A-Za-z0-9+/]+={0,2}$/;

      if (base64regex.test(base64)) {
        console.log("Valid Base64 string");
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
          bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
      } else {
        console.error("Invalid Base64 string");
      }

      // var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
      // if (base64regex.test(base64)) {
      //   var binary_string = window.atob(base64);
      //   var len = binary_string.length;
      //   var bytes = new Uint8Array(len);
      //   for (var i = 0; i < len; i++) {
      //     bytes[i] = binary_string.charCodeAt(i);
      //   }
      //   return bytes.buffer;
      // }
    }

    carouselInterval : any;
    startCarousel() {
      // Initialize the first slide and start the carousel loop
      this.showSlide();
    
      this.carouselInterval = setInterval(() => {
        this.nextSlide();
      }, 5000); // 5 seconds for each slide
    }
    
    showSlide() {
      this.isVisible = true;
    
      setTimeout(() => {
        this.isVisible = false;
      }, 3000); // Slide out after 3 seconds
    }
    
    nextSlide() {
      this.isVisible = false;
    
      setTimeout(() => {
        this.currentIndex = (this.currentIndex + 1) % this.texts.length;
        this.currentText = this.texts[this.currentIndex];
        this.showSlide();
      }, 1000); // Wait for slide-out transition (1s) before showing the next slide
    }
    
    prevSlide() {
      clearInterval(this.carouselInterval); // Stop automatic sliding when using manual controls
    
      this.isVisible = false;
    
      setTimeout(() => {
        this.currentIndex = (this.currentIndex - 1 + this.texts.length) % this.texts.length;
        this.currentText = this.texts[this.currentIndex];
        this.showSlide();
      }, 1000); // Wait for slide-out transition (1s) before showing the previous slide
    }   

downloadEncryptedJson(): void {
  let jsonData = this.documentInterpretationResp;
  let filename = `ErrorReport_${this.request_id}`
  // Convert JSON object to string
  const jsonStr = JSON.stringify(jsonData);

  // Encrypt the JSON string
  const encryptedData = CryptoJS.AES.encrypt(jsonStr, this.encryptionKey).toString();

  // Create a Blob from the encrypted string
  const blob = new Blob([encryptedData], { type: 'application/json' });

  // Create a URL for the Blob
  const url = window.URL.createObjectURL(blob);

  // Create a temporary <a> element to trigger the download
  const a = document.createElement('a');
  a.href = url;
  a.download = filename; // Set the filename
  document.body.appendChild(a);
  a.click(); // Programmatically click the <a> element to trigger the download
  document.body.removeChild(a); // Remove the <a> element after download
  window.URL.revokeObjectURL(url); // Clean up the URL object
}

decryptJson(encryptedData: string, encryptionKey: string): any {
  const bytes = CryptoJS.AES.decrypt(encryptedData, encryptionKey);
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData); // Parse the decrypted string back into JSON
}
   
setConfigForInterpretationMetrics(){
  this.chartOptions = {
    series: [this.interpretation_metrics['extracted_mandatory_data_points'],this.interpretation_metrics['failed_mandatory_data_points'],],
    chart: {
      width: 380,
      type: "donut"
    },
    labels : ["Mandatory Data Extracted", "Mandatory Data Failed"],
    colors: ['#5be7a9','#f95959'],
    dataLabels: {
      enabled: true
    },
    fill: {
      type: "gradient"
    },
    legend: {
      formatter: function(val, opts) {
        return val + " - " + opts.w.globals.series[opts.seriesIndex];
      }
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: "bottom"
          }
        }
      }
    ]
    };
  }
}
